import {
  useEffect,
  useCallback,
  useState,
  useMemo,
  Fragment,
  useRef,
} from "react";
import InfiniteScroll from "react-infinite-scroll-component";

import { useFormik, Form, FormikProvider, Field } from "formik";
import Token from "../../util/Token";
import {
  Stack,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  FormControlLabel,
  Checkbox,
  Tooltip,
  Select,
  FormHelperText,
  Card,
  Switch,
  IconButton,
  Button,
  Autocomplete,
  Box,
  FormLabel,
  RadioGroup,
  Radio,
  Chip,
  Paper,
  Collapse,
  IconButton as MuiIconButton,
  Alert,
  CircularProgress,
  TablePagination,
} from "@mui/material";
import * as Yup from "yup";
import PlusCircleFill from "@iconify/icons-eva/plus-circle-fill";
import InputAdornment from "@mui/material/InputAdornment";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import downloadFill from "@iconify/icons-eva/download-fill";
import { LoadingButton, TabContext, TabPanel } from "@mui/lab";
import {
  Link as RouterLink,
  useNavigate,
  useParams,
  useMatch,
  useLocation,
} from "react-router-dom";
import { Icon } from "@iconify/react";
import AlertCircleFill from "@iconify/icons-eva/alert-circle-fill";
import PlusFill from "@iconify/icons-eva/plus-fill";
import TrashOutline from "@iconify/icons-eva/trash-2-outline";
import closeFill from "@iconify/icons-eva/close-fill";
// import Countries from "../../data/countries.json";
import ConnectorType from "../../data/connectorType.json";
import { chargerFormValidationSchema } from "../../util/validationSchemas";
import "../../styles/charger.css";
import { useAccess } from "src/hooks/useAccess.hook";
import { useIsGrandParent } from "src/hooks/useIsGrandParent";
import { useDashboardV2Enabled } from "src/hooks/useDashboardV2Enabled";
import {
  ChargerFormTabs,
  NOTIFICATION_CONSTANTS,
  OCPP_AUTH_MODE_OPTIONS,
  getChargerDefaultValues,
  hideForTabs,
  reportIssuesColumn,
  statusHistoryColumns,
} from "./charger.constants";
import {
  chargerIdUrl,
  chargerUrl,
  getTeamUrl,
  viewLogsUrl,
  logsCountUrl,
  logFilterData,
} from "src/react-query/endPoints";
import { Loader } from "../Loader";
import { is } from "src/util/is";
import { useSelectedTeam } from "src/hooks/useSelectedTeam";
import { useGetDetail, useMutate, useList } from "src/hooks/useFetch.hook";
import { useDispatch, useSelector } from "react-redux";
import enums, { FEATURE } from "src/util/enums";
import Address, { parseGoogleAddress } from "src/common/components/Address";
import { AMENITIES } from "./charger.constants";
import ImgPreviewModal from "../ImagePreviewModal/ImgPreviewModal";
import { getIcon } from "src/utils/utility";

//actions
import { alertSlice } from "src/store/alert/alert.slice";
import whatsappService from "src/services/whatsappService";
import { RootTabItemStyles, RootTabStyle } from "src/theme/overrides/Tabs";
import { useInfiniteQuery, useQueryClient } from "@tanstack/react-query";
import { fetchInfinite } from "src/react-query/fetchWithError";
import { LogsData } from "./ViewLogsModal";
import { useMutation } from "@tanstack/react-query";
import { issueImgUpload } from "src/components/ServiceRequest/serviceRequest.hook";
import { fileToBase64 } from "src/utils/fileConvertBase64";
import Map from "src/common/components/Map";
import { OutlinedInput, ImageList, ImageListItem } from "@mui/material";
import { RemoteOperationForm } from "./RemoteOperation/RemoteOperationForm";
import { createYupSchema } from "src/utils/yupCreatorSchema";
import { DateTimePicker } from "../FormikDateTimePicker";

import { remoteOperationConfig } from "./RemoteOperation/remoteOperationConfig";
import { remoteOperations } from "./RemoteOperation/remote.constants";
import { tabsCurrentlyOpenedForSlice } from "src/store/tabsOpened/tabsOpened.slice";
import RemoteOpsStatusModal from "./RemoteOperation/RemoteOpsStatusModal";
import { ConnectorUpi } from "./ConnectorUpi";
import { remoteOpsStatusSlice } from "src/store/remoteOpsStatus/remoteOpsStatus.slice";
import { GridLabel } from "../Transactions/TransactionView";
import { BaseTable } from "../BaseTable/BaseTable";
import axios from "../../util/axios";
import { isValidTimeInterval, fChargerLogDateTime, fLogDateTimeInZone, parseDateTimeString, convertUTCToLocal } from "src/utils/formatTime";
import { format } from "date-fns";
import RefreshFill from "@iconify/icons-eva/refresh-fill";
import { downloadCSV } from "src/utils/convertAnddownloadCsv";
import { useDomainConfig } from "src/hooks/useDomainConfig";
import { useTeams } from "src/hooks/useTeams";
import ShareLocationButton from "./ShareLocationButton";
import { connectorStatusWhenOffline } from "src/utils/connectorStatus";

const {
  actions: { setAlert },
} = alertSlice;

const initialConnectors = [
  { connectorId: "", kw: "", volt: "", connectorType: "", connectorName: "" },
];

const initialFaq = [{ question: "", answer: "" }];

const downloadRazorPayQR = (url) => {
  const link = document.createElement("a");
  link.download = "PaymentQR.jpeg";
  link.href = url;
  link.click();
};

const downloadCMQR = (value) => {
  const qrCode = document.getElementById(`chargerqr-${value}`);
  const svgData = new XMLSerializer().serializeToString(qrCode);
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  const img = new Image();
  img.onload = () => {
    const padding = 20;
    const widthWithPadding = img.width + padding * 2;
    const heightWithPadding = img.height + padding * 2;
    canvas.width = widthWithPadding;
    canvas.height = heightWithPadding;
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, padding, padding);
    const pngFile = canvas.toDataURL("image/jpeg");
    const downloadLink = document.createElement("a");
    downloadLink.download = `${value}.jpeg`;
    downloadLink.href = `${pngFile}`;
    downloadLink.click();
  };
  img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;
};

const downloadUPIQR = (upiText) => {
  // Generate a unique ID for this QR code
  const qrId = `upiqr-${Date.now()}`;

  // Create a temporary QR code element
  const tempDiv = document.createElement("div");
  tempDiv.id = qrId;
  tempDiv.style.position = "absolute";
  tempDiv.style.left = "-9999px";
  document.body.appendChild(tempDiv);

  // Import QRCode dynamically or use existing one
  // We'll use the same approach as downloadCMQR
  setTimeout(() => {
    const qrCode = document.getElementById(qrId);
    if (qrCode) {
      const svgData = new XMLSerializer().serializeToString(qrCode.querySelector("svg"));
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const img = new Image();
      img.onload = () => {
        const padding = 20;
        const widthWithPadding = img.width + padding * 2;
        const heightWithPadding = img.height + padding * 2;
        canvas.width = widthWithPadding;
        canvas.height = heightWithPadding;
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, padding, padding);
        const pngFile = canvas.toDataURL("image/jpeg");
        const downloadLink = document.createElement("a");
        downloadLink.download = "UPI_QR.jpeg";
        downloadLink.href = `${pngFile}`;
        downloadLink.click();
        document.body.removeChild(tempDiv);
      };
      img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;
    }
  }, 100);

  // Return the QR code element for rendering
  return qrId;
};

// get current variable price.
const getActiveVariablePriceUTC = (priceDetails) => {
  if (!Array.isArray(priceDetails)) return null;

  const todayUtc = new Date().getUTCDay();
  const nowUtc = new Date().toISOString().slice(11, 19); // HH:mm:ss

  return priceDetails.find(
    (p) =>
      p.day === todayUtc &&
      p.startTime <= nowUtc &&
      p.endTime >= nowUtc
  ) || null;
};


// Enhanced LogsData Component
// Parse an OCPP-J log message string into its action and connectorId. Messages are
// arrays: [2,"<id>","<Action>",{payload}] for calls (requests) and
// [3,"<id>",{payload}] for call results (responses). connectorId, when present,
// lives in the payload object. Returns nulls for anything unparseable. Used only
// for client-side filtering, since cms_logs stores neither as a column.
// Format a single OCPP MeterValues sampledValue into a compact, human-readable string,
// normalising the common measurands to friendly units (Wh -> kWh, W -> kW, etc.). A
// missing measurand defaults to the energy register per the OCPP spec.
const formatSampledValue = (sv) => {
  if (!sv || sv.value == null) return null;
  const measurand = sv.measurand || "Energy.Active.Import.Register";
  const unit = sv.unit;
  const num = Number(sv.value);
  const hasNum = Number.isFinite(num);

  switch (measurand) {
    case "Energy.Active.Import.Register":
    case "Energy.Active.Export.Register":
      if (hasNum) {
        const kWh = unit === "kWh" ? num : num / 1000; // default unit is Wh
        return `${kWh.toFixed(2)} kWh`;
      }
      break;
    case "Power.Active.Import":
    case "Power.Active.Export":
      if (hasNum) {
        const kW = unit === "kW" ? num : num / 1000; // default unit is W
        return `${kW.toFixed(2)} kW`;
      }
      break;
    case "SoC":
      return `SoC ${sv.value}%`;
    case "Current.Import":
    case "Current.Offered":
      return `${sv.value} A`;
    case "Voltage":
      return `${sv.value} V`;
    case "Temperature":
      return `${sv.value}°C`;
    default:
      break;
  }
  return unit ? `${sv.value} ${unit}` : `${sv.value}`;
};

// Build a compact one-line summary of a MeterValues payload, using the most recent
// meterValue sample. Returns null when there is nothing meaningful to show.
const formatMeterValues = (payload) => {
  const meterValues = Array.isArray(payload?.meterValue) ? payload.meterValue : [];
  if (meterValues.length === 0) return null;
  const latest = meterValues[meterValues.length - 1];
  const samples = Array.isArray(latest?.sampledValue) ? latest.sampledValue : [];
  const parts = samples.map(formatSampledValue).filter(Boolean);
  return parts.length > 0 ? parts.join(" · ") : null;
};

const parseOcppMessage = (message) => {
  try {
    const arr = JSON.parse(message);
    if (!Array.isArray(arr)) return { action: null, connectorId: null, meter: null };
    if (arr[0] === 2) {
      const payload = arr[3] && typeof arr[3] === "object" ? arr[3] : null;
      const action = typeof arr[2] === "string" ? arr[2] : null;
      return {
        action,
        connectorId:
          payload && payload.connectorId != null ? payload.connectorId : null,
        // For MeterValues, surface the reading(s) inline so operators can see them
        // without expanding the row.
        meter: action === "MeterValues" && payload ? formatMeterValues(payload) : null,
      };
    }
    // Call result / error: the payload (if any) is the 3rd element; no action.
    const payload = arr[2] && typeof arr[2] === "object" ? arr[2] : null;
    return {
      action: null,
      connectorId:
        payload && payload.connectorId != null ? payload.connectorId : null,
      meter: null,
    };
  } catch (e) {
    return { action: null, connectorId: null, meter: null };
  }
};

// Known OCPP 1.6 actions, used to populate the Action filter dropdown. Kept static so
// the list is complete regardless of which actions are present in the loaded page
// (the server filters on the raw action string parsed from the message).
const OCPP_ACTIONS = [
  "Authorize",
  "BootNotification",
  "CancelReservation",
  "ChangeAvailability",
  "ChangeConfiguration",
  "ClearCache",
  "ClearChargingProfile",
  "DataTransfer",
  "DiagnosticsStatusNotification",
  "FirmwareStatusNotification",
  "GetCompositeSchedule",
  "GetConfiguration",
  "GetDiagnostics",
  "GetLocalListVersion",
  "Heartbeat",
  "MeterValues",
  "RemoteStartTransaction",
  "RemoteStopTransaction",
  "ReserveNow",
  "Reset",
  "SendLocalList",
  "SetChargingProfile",
  "StartTransaction",
  "StatusNotification",
  "StopTransaction",
  "TriggerMessage",
  "UnlockConnector",
  "UpdateFirmware",
];

// The viewer's own timezone, used as the default for the logs timezone selector.
const BROWSER_TIME_ZONE = (() => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch (e) {
    return "UTC";
  }
})();

// Full IANA zone list when the browser supports it (modern Chrome/Edge/Firefox/Safari),
// else a curated fallback. UTC and the viewer's own zone are always included first.
const TIME_ZONES = (() => {
  let zones = [];
  try {
    if (typeof Intl.supportedValuesOf === "function") {
      zones = Intl.supportedValuesOf("timeZone");
    }
  } catch (e) {
    zones = [];
  }
  if (!zones || zones.length === 0) {
    zones = [
      "Asia/Kolkata",
      "Europe/London",
      "Europe/Paris",
      "America/New_York",
      "America/Chicago",
      "America/Los_Angeles",
      "Asia/Dubai",
      "Asia/Singapore",
      "Asia/Tokyo",
      "Australia/Sydney",
    ];
  }
  return Array.from(new Set(["UTC", BROWSER_TIME_ZONE, ...zones]));
})();

const LOG_TZ_STORAGE_KEY = "cmsLogTimeZone";

const EnhancedLogsData = ({
  data,
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
  hasTimeFilter = false,
  onExport,
  filters,
  onFilterChange,
  connectors,
  logCounts,
}) => {
  const [expandedLogs, setExpandedLogs] = useState({});

  // Timezone used to render every log timestamp. Defaults to the viewer's own zone and
  // is remembered per browser. All timestamps come from the backend as UTC.
  const [timeZone, setTimeZone] = useState(() => {
    try {
      return localStorage.getItem(LOG_TZ_STORAGE_KEY) || BROWSER_TIME_ZONE;
    } catch (e) {
      return BROWSER_TIME_ZONE;
    }
  });
  useEffect(() => {
    try {
      if (timeZone) localStorage.setItem(LOG_TZ_STORAGE_KEY, timeZone);
    } catch (e) {
      /* storage unavailable - ignore */
    }
  }, [timeZone]);

  // Filters are controlled by the parent and applied SERVER-SIDE across the charger's
  // full log history (not just the loaded page). Reading straight from props keeps the
  // controls in sync with the actual query; setters send a patch back up.
  const filterType = filters?.messageType ?? "ALL"; // ALL | INCOMING | OUTGOING
  const connectorFilter = filters?.connector ?? "ALL";
  const actionFilter = Array.isArray(filters?.action) ? filters.action : []; // multi-select
  const searchText = filters?.search ?? "";
  const setFilterType = (v) => onFilterChange?.({ messageType: v });

  // The panel filters (connector / actions / search) are STAGED locally and only sent
  // to the server query when the user clicks "Apply filters". This stops every pick from
  // refetching (which used to remount the viewer and close the Actions dropdown after a
  // single selection, blocking multi-select). The direction chips above apply at once.
  const [pending, setPending] = useState({
    connector: connectorFilter,
    action: actionFilter,
    search: searchText,
  });
  // A stable signature of the APPLIED filters; re-sync the staged values whenever they
  // change elsewhere (Clear filters, or right after an Apply).
  const appliedSig = `${connectorFilter}|${actionFilter.join(",")}|${searchText}`;
  useEffect(() => {
    setPending({
      connector: connectorFilter,
      action: actionFilter,
      search: searchText,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appliedSig]);
  const pendingSig = `${pending.connector}|${pending.action.join(",")}|${pending.search}`;
  const hasPendingChanges = pendingSig !== appliedSig;
  const anyFilterActive =
    filterType !== "ALL" ||
    pending.connector !== "ALL" ||
    pending.action.length > 0 ||
    !!pending.search ||
    connectorFilter !== "ALL" ||
    actionFilter.length > 0 ||
    !!searchText;
  const applyFilters = () =>
    onFilterChange?.({
      connector: pending.connector,
      action: pending.action,
      search: pending.search,
    });
  const clearFilters = () => {
    setFilterType("ALL");
    onFilterChange?.({ connector: "ALL", action: [], search: "" });
  };

  const toggleLogExpansion = (logIndex) => {
    setExpandedLogs((prev) => ({
      ...prev,
      [logIndex]: !prev[logIndex],
    }));
  };

  const logKeyOf = (log, index) =>
    log?.idcms_logs ?? log?.messageId ?? index;

  const expandAllLogs = () => {
    if (!data?.pages) return;
    const all = data.pages.flat();
    const expandedState = {};
    all.forEach((log, index) => {
      expandedState[logKeyOf(log, index)] = true;
    });
    setExpandedLogs(expandedState);
  };

  const collapseAllLogs = () => {
    setExpandedLogs({});
  };

  const allLogs = useMemo(() => {
    if (!data?.pages) return [];
    return data.pages.flat();
  }, [data]);

  // Parse each log's OCPP payload once for per-row display (action, connectorId, meter).
  const parsedLogs = useMemo(
    () =>
      allLogs.map((log) => {
        const { action, connectorId, meter } = parseOcppMessage(log.message);
        return { ...log, _action: action, _connectorId: connectorId, _meter: meter };
      }),
    [allLogs]
  );

  // Connector options come from the charger's actual configured connectors (passed in),
  // NOT from parsing log payloads. Connector 0 is the OCPP station-level id, not a
  // physical connector, so it is excluded.
  const connectorOptions = useMemo(() => {
    const list = Array.isArray(connectors) ? connectors : [];
    const ids = list
      .map((c) => c?.connectorId ?? c?.connector_id ?? c?.id)
      .filter((n) => n != null && Number(n) !== 0)
      .map((n) => String(n));
    return Array.from(new Set(ids)).sort((a, b) => Number(a) - Number(b));
  }, [connectors]);

  // Action options are the known OCPP-J actions (static).
  const actionOptions = OCPP_ACTIONS;

  // Filtering AND pagination are handled SERVER-SIDE: each loaded page already contains
  // exactly the filtered rows in order, so we render the loaded rows directly and load
  // the next page by scrolling to the bottom (Live mode). No client-side filtering or
  // slicing — that dual layer was the source of the count/display mismatches.
  const displayLogs = parsedLogs;

  // Auto-expand all logs ONCE on the first non-empty load. Re-running on every data
  // change would fight the user's manual expand/collapse and, in Live mode, reset
  // expansion on every auto-refresh (every 10s). Expand All / Collapse All remain
  // available for bulk control.
  const didInitialExpandRef = useRef(false);
  useEffect(() => {
    if (!didInitialExpandRef.current && allLogs && allLogs.length > 0) {
      const expandedState = {};
      allLogs.forEach((log, index) => {
        expandedState[logKeyOf(log, index)] = true;
      });
      setExpandedLogs(expandedState);
      didInitialExpandRef.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allLogs.length]);

  // Expose the loaded (server-filtered) logs for CSV export via ref.
  useEffect(() => {
    if (onExport) {
      onExport.current = () => parsedLogs;
    }
  }, [parsedLogs, onExport]);

  // Real per-direction totals come from the server COUNT endpoint (see parent), so the
  // chips show the true totals for the current filters/window — not a "loaded so far"
  // number. They ignore the direction filter itself so both stay visible.
  const incomingCount = logCounts?.incoming ?? 0;
  const outgoingCount = logCounts?.outgoing ?? 0;
  const totalCountLabel = logCounts?.total ?? incomingCount + outgoingCount;

  const expandedCount = Object.values(expandedLogs).filter(Boolean).length;
  const loadedLogs = parsedLogs.length;

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Filter Controls */}
      <Box
        sx={{
          p: 2,
          borderBottom: "1px solid rgba(0,0,0,0.1)",
          background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
          display: "flex",
          gap: 1,
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: 1,
            flexWrap: "wrap",
            alignItems: "center",
          }}
        >
          {/* Connector / action / free-text filters. Staged locally; applied on click. */}
          <TextField
            select
            size="small"
            label="Connector"
            value={pending.connector}
            onChange={(e) =>
              setPending((p) => ({ ...p, connector: e.target.value }))
            }
            sx={{ minWidth: 130, backgroundColor: "#fff", borderRadius: 1 }}
          >
            <MenuItem value="ALL">All connectors</MenuItem>
            {connectorOptions.map((c) => (
              <MenuItem key={c} value={c}>
                Connector {c}
              </MenuItem>
            ))}
          </TextField>
          <Autocomplete
            multiple
            size="small"
            disableCloseOnSelect
            limitTags={2}
            options={actionOptions}
            value={pending.action}
            onChange={(e, newValue) =>
              setPending((p) => ({ ...p, action: newValue }))
            }
            sx={{ minWidth: 240, backgroundColor: "#fff", borderRadius: 1 }}
            renderOption={(props, option, { selected }) => (
              <li {...props} key={option}>
                <Checkbox
                  size="small"
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option}
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Actions"
                placeholder={pending.action.length ? "" : "All actions"}
              />
            )}
          />
          <TextField
            size="small"
            label="Search"
            placeholder="message, id, value…"
            value={pending.search}
            onChange={(e) =>
              setPending((p) => ({ ...p, search: e.target.value }))
            }
            onKeyDown={(e) => {
              if (e.key === "Enter" && hasPendingChanges) applyFilters();
            }}
            sx={{ minWidth: 190, backgroundColor: "#fff", borderRadius: 1 }}
          />
          <Button
            size="small"
            variant="contained"
            onClick={applyFilters}
            disabled={!hasPendingChanges}
            startIcon={<Icon icon="eva:funnel-outline" width={16} height={16} />}
            sx={{
              textTransform: "none",
              fontSize: "0.75rem",
              fontWeight: 600,
              borderRadius: 2,
              boxShadow: "none",
            }}
          >
            Apply filters
          </Button>
          {anyFilterActive && (
            <Button
              size="small"
              variant="text"
              onClick={clearFilters}
              sx={{ textTransform: "none", fontSize: "0.75rem" }}
            >
              Clear filters
            </Button>
          )}
        </Box>

        <Box
          sx={{
            display: "flex",
            gap: 1,
            alignItems: "center",
            justifyContent: "flex-end",
            flexWrap: "wrap",
          }}
        >
          {/* Log Statistics */}
          <Typography
            variant="caption"
            sx={{
              color: "text.secondary",
              fontWeight: 500,
              whiteSpace: "nowrap",
              px: 1.5,
              py: 0.5,
              backgroundColor: hasTimeFilter
                ? "rgba(255, 152, 0, 0.1)"
                : "rgba(25, 118, 210, 0.1)",
              borderRadius: 1,
              border: hasTimeFilter
                ? "1px solid rgba(255, 152, 0, 0.2)"
                : "1px solid rgba(25, 118, 210, 0.2)",
            }}
          >
            {hasTimeFilter
              ? "🔍 Time range (no auto-refresh)"
              : "📊 Live logs · last 24h (auto-refresh)"}{" "}
            |
            {expandedCount > 0 && (
              <span style={{ color: "#1976d2", fontWeight: 600 }}>
                {expandedCount}/{loadedLogs} expanded
              </span>
            )}
            {expandedCount === 0 &&
              `Loaded ${loadedLogs} of ${totalCountLabel} logs`}
          </Typography>

          {/* Direction filter (All / Incoming / Outgoing) — moved here from the top */}
          <Box sx={{ display: "flex", gap: 0.5, alignItems: "center", ml: "auto" }}>
            <Chip
              label={`All (${incomingCount + outgoingCount})`}
              onClick={() => setFilterType("ALL")}
              color={filterType === "ALL" ? "primary" : "default"}
              variant={filterType === "ALL" ? "filled" : "outlined"}
              size="small"
            />
            <Chip
              label={`Incoming (${incomingCount})`}
              onClick={() => setFilterType("INCOMING")}
              color={filterType === "INCOMING" ? "primary" : "default"}
              variant={filterType === "INCOMING" ? "filled" : "outlined"}
              size="small"
              sx={{
                backgroundColor:
                  filterType === "INCOMING" ? "#e3f2fd" : "transparent",
                color: filterType === "INCOMING" ? "#1976d2" : "inherit",
              }}
            />
            <Chip
              label={`Outgoing (${outgoingCount})`}
              onClick={() => setFilterType("OUTGOING")}
              color={filterType === "OUTGOING" ? "primary" : "default"}
              variant={filterType === "OUTGOING" ? "filled" : "outlined"}
              size="small"
              sx={{
                backgroundColor:
                  filterType === "OUTGOING" ? "#e8f5e8" : "transparent",
                color: filterType === "OUTGOING" ? "#2e7d32" : "inherit",
              }}
            />
          </Box>

          {/* Expand/Collapse All — icon buttons, right-aligned */}
          <Box sx={{ display: "flex", gap: 0.5 }}>
            <Tooltip title="Expand all">
              <IconButton
                size="small"
                onClick={expandAllLogs}
                sx={{
                  border: "1px solid #DFE3E8",
                  borderRadius: 2,
                  color: "#1976d2",
                  "&:hover": {
                    backgroundColor: "#e3f2fd",
                    borderColor: "#1976d2",
                  },
                }}
              >
                <Icon icon="eva:expand-outline" width={18} height={18} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Collapse all">
              <IconButton
                size="small"
                onClick={collapseAllLogs}
                sx={{
                  border: "1px solid #DFE3E8",
                  borderRadius: 2,
                  color: "#2e7d32",
                  "&:hover": {
                    backgroundColor: "#e8f5e8",
                    borderColor: "#2e7d32",
                    color: "#1b5e20",
                  },
                }}
              >
                <Icon icon="eva:collapse-outline" width={18} height={18} />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Box>

      {/* Logs Container with Infinite Scroll */}
      <Box
        sx={{
          flex: 1,
          overflow: "auto",
          minHeight: "400px",
          maxHeight: "600px",
          maxWidth: "100%",
          width: "100%",
          "&::-webkit-scrollbar": {
            width: "8px",
          },
          "&::-webkit-scrollbar-track": {
            background: "#f1f1f1",
            borderRadius: "4px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#c1c1c1",
            borderRadius: "4px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            background: "#a8a8a8",
          },
        }}
        id="logs-scroll-container"
      >
        <Box sx={{ pb: 3 }}>
          {(() => {
            const renderedLogs = displayLogs.map((logRow, localIndex) => {
              const {
                messageTime,
                messageType,
                message,
                _action,
                _connectorId,
                _meter,
              } = logRow;
              const logIndex = logKeyOf(logRow, localIndex);
              const isExpanded = expandedLogs[logIndex];
                const isIncoming = messageType === "INCOMING";

                return (
                  <Paper
                    key={logIndex}
                    elevation={1}
                    sx={{
                      m: 1,
                      borderRadius: 2,
                      overflow: "hidden",
                      border: `2px solid ${isIncoming ? "#e3f2fd" : "#e8f5e8"}`,
                      background: isIncoming
                        ? "linear-gradient(135deg, #f8f9ff 0%, #e3f2fd 100%)"
                        : "linear-gradient(135deg, #f8fff8 0%, #e8f5e8 100%)",
                      // Transitions removed
                      maxWidth: "100%",
                      width: "100%",
                      "&:hover": {
                        // Hover effects removed
                      },
                    }}
                  >
                    {/* Log Header */}
                    <Box
                      sx={{
                        p: 2,
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        minHeight: "60px",
                      }}
                      onClick={() => toggleLogExpansion(logIndex)}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 2,
                          flex: 1,
                          minWidth: 0,
                          maxWidth: "100%",
                          overflow: "hidden",
                        }}
                      >
                        {/* Message Type Badge */}
                        <Chip
                          label={messageType}
                          size="small"
                          sx={{
                            backgroundColor: isIncoming ? "#1976d2" : "#2e7d32",
                            color: "white",
                            fontWeight: 600,
                            minWidth: "80px",
                            fontSize: "0.75rem",
                          }}
                        />

                        {/* Parsed OCPP action + connector + meter reading (when present) */}
                        {(_action || _connectorId != null) && (
                          <Chip
                            label={`${_action || "—"}${
                              _connectorId != null ? ` · C${_connectorId}` : ""
                            }${_meter ? ` · ${_meter}` : ""}`}
                            size="small"
                            variant="outlined"
                            sx={{
                              fontWeight: 600,
                              fontSize: "0.7rem",
                              borderColor: "rgba(0,0,0,0.2)",
                              whiteSpace: "nowrap",
                            }}
                          />
                        )}

                        {/* Timestamp */}
                        <Typography
                          variant="caption"
                          sx={{
                            color: "text.secondary",
                            fontWeight: 500,
                            fontSize: "0.8rem",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {fLogDateTimeInZone(messageTime, timeZone)}
                        </Typography>

                        {/* Message Preview*/}
                        <Typography
                          variant="body2"
                          sx={{
                            color: "text.primary",
                            fontWeight: 500,
                            flex: 1,
                            minWidth: 0,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            ml: 1,
                            maxWidth: "300px",
                          }}
                        >
                          {message.length > 100
                            ? `${message.substring(0, 100)}...`
                            : message}
                        </Typography>
                      </Box>

                      {/* Expand/Collapse Icon */}
                      <MuiIconButton size="small" sx={{ ml: 1 }}>
                        <Icon icon="eva:arrow-ios-downward-outline" width={20} height={20} />
                      </MuiIconButton>
                    </Box>

                    {/* Expanded Content */}
                    <Collapse in={isExpanded}>
                      <Box
                        sx={{
                          p: 2,
                          pt: 0,
                          borderTop: "1px solid rgba(0,0,0,0.1)",
                          background: "rgba(255,255,255,0.7)",
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            fontFamily: "monospace",
                            fontSize: "0.8rem",
                            lineHeight: 1.6,
                            wordBreak: "break-word",
                            overflowWrap: "break-word",
                            whiteSpace: "pre-wrap",
                            color: "text.primary",
                            background: "rgba(0,0,0,0.02)",
                            p: 2,
                            borderRadius: 1,
                            border: "1px solid rgba(0,0,0,0.1)",
                            maxWidth: "100%",
                            overflow: "hidden",
                          }}
                        >
                          {message}
                        </Typography>
                      </Box>
                    </Collapse>
                  </Paper>
                );
              }
            );

            if (hasTimeFilter) return renderedLogs;

            return (
              <InfiniteScroll
                dataLength={displayLogs.length}
                next={() => {
                  if (hasNextPage && !isFetchingNextPage) fetchNextPage();
                }}
                hasMore={hasNextPage && !isFetchingNextPage}
                threshold={200}
                loader={
                  <Box sx={{ p: 2, textAlign: "center" }}>
                    <Typography variant="body2" color="text.secondary">
                      Loading more logs…
                    </Typography>
                  </Box>
                }
                endMessage={
                  displayLogs.length > 0 ? (
                    <Box sx={{ p: 2, textAlign: "center" }}>
                      <Typography variant="caption" color="text.secondary">
                        End of logs · {displayLogs.length} loaded
                      </Typography>
                    </Box>
                  ) : null
                }
                scrollableTarget="logs-scroll-container"
                style={{ overflow: "visible" }}
              >
                {renderedLogs}
              </InfiniteScroll>
            );
          })()}
            
            {displayLogs.length === 0 && isFetchingNextPage && (
              <Box sx={{ p: 4, textAlign: "center" }}>
                <CircularProgress size={30} />
                <Typography variant="body2" sx={{ mt: 1, color: "text.secondary" }}>
                  Fetching logs...
                </Typography>
              </Box>
            )}

            {/* No results for the applied filters — the toolbar above stays available
                so the user can adjust or clear the filters. */}
            {displayLogs.length === 0 && !isFetchingNextPage && (
              <Box sx={{ p: 5, textAlign: "center" }}>
                <Icon
                  icon="eva:funnel-outline"
                  width={34}
                  height={34}
                  style={{ color: "#919EAB" }}
                />
                <Typography
                  variant="body2"
                  sx={{ mt: 1, color: "text.secondary" }}
                >
                  No logs match the current filters. Adjust them above and press
                  Apply, or clear the filters.
                </Typography>
              </Box>
            )}
          </Box>
      </Box>

      {/* Footer: real total for the current filters/window (from the server COUNT) + timezone selector */}
      <Box
        sx={{
          borderTop: "1px solid rgba(0,0,0,0.1)",
          px: 2,
          py: 1,
          backgroundColor: "#fff",
          borderRadius: "0 0 12px 12px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 1.5,
          flexWrap: "wrap",
        }}
      >
        <Typography variant="caption" color="text.secondary">
          {`Loaded ${loadedLogs} of ${totalCountLabel} logs`}
          {hasNextPage ? " · scroll to load more" : ""}
          {` · ${incomingCount} incoming / ${outgoingCount} outgoing`}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography
            variant="caption"
            sx={{ color: "text.secondary", fontWeight: 600, whiteSpace: "nowrap" }}
          >
            Timezone:
          </Typography>
          <Autocomplete
            size="small"
            disableClearable
            options={TIME_ZONES}
            value={timeZone}
            onChange={(e, newValue) => newValue && setTimeZone(newValue)}
            sx={{
              minWidth: 210,
              maxWidth: "100%",
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
                background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                fontSize: "0.8rem",
                "& fieldset": { borderColor: "rgba(0,0,0,0.12)" },
                "&:hover fieldset": { borderColor: "#1976d2" },
                "&.Mui-focused fieldset": { borderColor: "#1976d2" },
              },
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select timezone"
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <InputAdornment position="start">
                      <Icon
                        icon="eva:globe-2-outline"
                        width={16}
                        height={16}
                        color="#1976d2"
                      />
                    </InputAdornment>
                  ),
                }}
              />
            )}
          />
        </Box>
      </Box>
    </Box>
  );
};

// Component to display price information for a selected price group
// Fetches individual price group details via API
const PriceGroupPriceDisplay = ({ priceGroupId }) => {
  // Fetch individual price group details
  const { data: priceGroupDetail, isFetching } = useGetDetail("priceGroup", {
    id: priceGroupId,
  });

  // Use useMemo to recalculate when priceGroupDetail changes
  const priceInfo = useMemo(() => {
    // Don't calculate if still loading or no price group selected
    if (isFetching || !priceGroupId || !priceGroupDetail) {
      return null;
    }

    // Get priceDetails from the fetched data
    const priceDetails = priceGroupDetail.priceDetails || priceGroupDetail.price_details;

    if (!Array.isArray(priceDetails) || priceDetails.length === 0) {
      return null;
    }

    let priceDetail = null;

    if (priceGroupDetail.priceGroupType === "variable") {
      priceDetail = getActiveVariablePriceUTC(priceDetails);
    } else {
      priceDetail = priceDetails[0];
    }

    // Find the first price detail with a valid price value
    // const priceDetail = priceDetails.find(detail => {
    //     const priceType = detail.priceType || detail.price_type;
    //   const priceperKW = detail.priceperKW || detail.priceper_kw || detail.price_per_kw;
    //   const priceperHr = detail.priceperHr || detail.priceper_hr || detail.price_per_hr;
    //   const priceperMin = detail.priceperMin || detail.priceper_min || detail.price_per_min;

    //   if (priceType === enums.PRICE_PER.KWH && priceperKW && parseFloat(priceperKW) > 0) {
    //       return true;
    //   } else if ((priceType === enums.PRICE_PER.MIN || priceType === enums.PRICE_PER.HR) && 
    //              ((priceperHr && parseFloat(priceperHr) > 0) || (priceperMin && parseFloat(priceperMin) > 0))) {
    //       return true;
    //     }
    //     return false;
    //   }) || priceDetails[0];

    if (!priceDetail) {
      return null;
    }

    // Handle different property name variations
    const priceType = priceDetail.priceType || priceDetail.price_type;
    const priceperKW = priceDetail.priceperKW || priceDetail.priceper_kw || priceDetail.price_per_kw;
    const priceperHr = priceDetail.priceperHr || priceDetail.priceper_hr || priceDetail.price_per_hr;
    const priceperMin = priceDetail.priceperMin || priceDetail.priceper_min || priceDetail.price_per_min;

    let info = null;

    if (priceType === enums.PRICE_PER.KWH && priceperKW) {
      const priceValue = parseFloat(priceperKW);
      if (!isNaN(priceValue) && priceValue > 0) {
        info = {
          type: "kwh",
          value: priceValue,
          label: "Price per kWh",
          currency: priceGroupDetail?.currency || "INR"
        };
      }
    } else if (priceType === enums.PRICE_PER.MIN || priceType === enums.PRICE_PER.HR) {
      // If priceperHr is set, convert to per minute, otherwise use priceperMin
      if (priceperHr && parseFloat(priceperHr) > 0) {
        const pricePerMin = parseFloat(priceperHr) / 60;
        info = {
          type: "min",
          value: pricePerMin,
          label: "Price per minute",
          currency: priceGroupDetail?.currency || "INR"
        };
      } else if (priceperMin && parseFloat(priceperMin) > 0) {
        info = {
          type: "min",
          value: parseFloat(priceperMin),
          label: "Price per minute",
          currency: priceGroupDetail?.currency || "INR"
        };
      }
    }

    return info;
  }, [priceGroupId, priceGroupDetail, isFetching]);

  if (!priceInfo) {
    return null;
  }

  return (
    <Typography
      variant="caption"
      sx={{
        mt: 0.5,
        display: "block",
        color: "text.secondary",
        fontSize: "0.75rem",
      }}
    >
      {priceInfo.label}: {priceInfo.value.toFixed(2)} {priceInfo.currency}
    </Typography>
  );
};

export default function ChargerForm() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const queryClient = useQueryClient();
  const hasReadOnlyAccess = useAccess(FEATURE.CHARGER, "R");
  const isCreateCharger = useMatch("/charger/new");
  const isReadOnly = hasReadOnlyAccess && !isCreateCharger;
  const isGrandParent = useIsGrandParent();
  const dashboardV2Enabled = useDashboardV2Enabled();
  const [showOcppPassword, setShowOcppPassword] = useState(false);
  // The Chargebox ID is the charger's identity and is referenced by foreign keys
  // (connectors, transactions, QR codes...). It's freely set while creating, but
  // once the charger exists it stays locked to avoid breaking those references —
  // only a super admin (Grand Parent) may override and edit it when required.
  const canEditChargerId = Boolean(isCreateCharger) || isGrandParent;
  // OCPP security (Settings tab) is super-admin only; the API enforces it too.
  const ocppSecurityReadOnly = isReadOnly || !isGrandParent;
  const { teamId } = useSelectedTeam();
  const [logDetailData, setLogDetailData] = useState();
  const { data: charger, isFetching, isLoading: isChargerLoading, error: chargerError } = useGetDetail("charger", { id });
  const { data: priceGroups, isFetching: isPriceGroupsFetching } = useList(
    "priceGroups", 
    isCreateCharger ? true : !!charger?.companyId, 
    isCreateCharger ? undefined : charger?.companyId
  );
  const [companyId, setCompanyId] = useState(null);
  const [companyType, setCompanyType] = useState("");
  const [userType, setUserType] = useState("");
  const [timeInterval, setTimeInterval] = useState({
    startDate: "",
    endDate: "",
  });
  const [hasTimeFilter, setHasTimeFilter] = useState(false); // Track if user has applied time filter
  // Quick-range selection for the logs view. "LIVE" tails the newest logs with
  // auto-refresh; a numeric string is the selected "last N minutes" preset; "CUSTOM"
  // means the date pickers are in use.
  const [logRangePreset, setLogRangePreset] = useState("LIVE");
  const [livePolling, setLivePolling] = useState(true); // auto-refresh in Live mode
  const [isDateInputFocused, setIsDateInputFocused] = useState(false); // Track if user is selecting dates
  const hasAutoLoadedRef = useRef(false); // Track if we've already auto-loaded for this tab selection
  const dateInputBlurTimeoutRef = useRef(null); // Store timeout for date input blur
  const getFilteredLogsRef = useRef(null); // Ref to get filtered logs from EnhancedLogsData

  // Server-side log filters. These are applied by the API across the charger's full
  // log history (not just the loaded page). `logSearchDebounced` feeds the query so
  // typing in the search box doesn't refetch on every keystroke.
  const [logFilters, setLogFilters] = useState({
    messageType: "ALL", // ALL | INCOMING | OUTGOING
    connector: "ALL", // "ALL" or a connector number
    action: [], // array of OCPP actions (empty = all actions)
    search: "",
  });
  const [logSearchDebounced, setLogSearchDebounced] = useState("");
  // Real totals (per direction) from the server COUNT endpoint, so the chips show the
  // true count for the current filters/window instead of a "loaded so far" number.
  const [logCounts, setLogCounts] = useState({ total: 0, incoming: 0, outgoing: 0 });
  // The UTC-formatted window currently applied (set by fetchLogFilterData); null in Live.
  const [logWindowParams, setLogWindowParams] = useState(null);

  useEffect(() => {
    const t = setTimeout(() => setLogSearchDebounced(logFilters.search), 400);
    return () => clearTimeout(t);
  }, [logFilters.search]);

  // Build the "?connector=1&action=MeterValues&..." suffix sent to the logs API.
  // Empty when no filter is active, so the request is identical to the old behaviour.
  const logFilterQuery = useMemo(() => {
    const params = new URLSearchParams();
    if (logFilters.messageType && logFilters.messageType !== "ALL")
      params.set("messageType", logFilters.messageType);
    if (logFilters.connector && logFilters.connector !== "ALL")
      params.set("connector", logFilters.connector);
    if (Array.isArray(logFilters.action) && logFilters.action.length > 0)
      params.set("action", logFilters.action.join(","));
    if (logSearchDebounced && logSearchDebounced.trim() !== "")
      params.set("q", logSearchDebounced.trim());
    const s = params.toString();
    return s ? `?${s}` : "";
  }, [
    logFilters.messageType,
    logFilters.connector,
    // join so the memo re-runs on content change, not array identity
    Array.isArray(logFilters.action) ? logFilters.action.join(",") : "",
    logSearchDebounced,
  ]);

  // Helper function to safely format dates
  const safeFormatDate = (date, formatString) => {
    if (!date || !(date instanceof Date) || isNaN(date.getTime())) {
      return "";
    }
    try {
      return format(date, formatString);
    } catch (error) {
      console.warn("Date formatting error:", error);
      return "";
    }
  };

  // Helper function to format date for datetime-local input (displays in local time)
  const formatDateForInput = (date) => {
    if (!date) {
      return "";
    }

    try {
      let dateObj;

      // Check if it's already a Date object
      if (date instanceof Date) {
        dateObj = date;
      } else if (typeof date === "string") {
        // Handle different string formats
        if (date.includes("/")) {
          // Handle DD/MM/YYYY format like "24/09/2025 11:03:18"
          const parts = date.split(" ");
          const datePart = parts[0]; // "24/09/2025"
          const timePart = parts[1] || "00:00:00"; // "11:03:18"

          const [day, month, year] = datePart.split("/");
          const [hours, minutes, seconds] = timePart.split(":");

          // Create Date object (month is 0-indexed)
          dateObj = new Date(year, month - 1, day, hours, minutes, seconds);
        } else {
          // Handle other formats
          dateObj = new Date(date);
        }
      } else {
        return "";
      }

      if (isNaN(dateObj.getTime())) {
        return "";
      }

      // Format the date in local timezone for the datetime-local input
      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, "0");
      const day = String(dateObj.getDate()).padStart(2, "0");
      const hours = String(dateObj.getHours()).padStart(2, "0");
      const minutes = String(dateObj.getMinutes()).padStart(2, "0");

      return `${year}-${month}-${day}T${hours}:${minutes}`;
    } catch (error) {
      console.warn("Date formatting error:", error);
      return "";
    }
  };
  const [searchData, setSearchData] = useState(true);
  const [isFetchingLogs, setIsFetchingLogs] = useState(false);
  const [statusHistory, setStatusHistory] = useState([]);
  // Preselect a connector in the Status History tab when the caller deep-links to
  // a specific faulted connector (e.g. from the dashboard Health column).
  const deepLinkLocation = useLocation();
  const [statusHistoryConnectorId, setStatusHistoryConnectorId] = useState(
    deepLinkLocation?.state?.statusConnectorId != null
      ? String(deepLinkLocation.state.statusConnectorId)
      : ""
  );
  const [statusHistoryLoading, setStatusHistoryLoading] = useState(false);
  const [statusHistoryError, setStatusHistoryError] = useState("");
  const [statusHistoryPage, setStatusHistoryPage] = useState(0);
  const [statusHistoryPageSize, setStatusHistoryPageSize] = useState(10);
  const [statusHistoryTotal, setStatusHistoryTotal] = useState(0);

  const normalizedStatusHistory = useMemo(
    () =>
      statusHistory.map((item, index) => ({
        id: index,
        status: item.status || "",
        timestamp: item.status_timestamp || "",
        error_code: item.error_code || "",
        error_info: item.error_info || "",
        vendor_id: item.vendor_id || "",
        vendor_error_code: item.vendor_error_code || "",
      })),
    [statusHistory]
  );
  const domainConfig = useDomainConfig();
  // Fetch teams if companyType is "P"
  useEffect(() => {
    const parsedToken = Token.parsedToken();
    if (parsedToken.success) {
      const { companyType, companyId, userType } = parsedToken.data;
      setCompanyType(companyType);
      setCompanyId(companyId);
      setUserType(userType);
    }
  }, []);

  const { data: teams } = useTeams(companyId);

  // Get redux data and selected tab before useInfiniteQuery to avoid initialization errors
  const {
    tabOpened,
    tabOpenedFor,
    data: reduxData,
  } = useSelector(({ tabsCurrentlyOpenedFor }) => tabsCurrentlyOpenedFor);
  const [selectedTab, setSelectedTab] = useState(
    tabOpenedFor === "charger" && tabOpened ? tabOpened : "general"
  );

  // Sync selectedTab with Redux tabOpened when it changes
  useEffect(() => {
    if (tabOpenedFor === "charger" && tabOpened) {
      setSelectedTab(tabOpened);
    }
  }, [tabOpened, tabOpenedFor]);

  const {
    data: logsData,
    hasNextPage,
    fetchNextPage,
    refetch,
    isFetching: isLogsFetching,
    isRefetching: isLogsRefetching,
    isFetchingNextPage,
  } = useInfiniteQuery(
    [
      "viewLogs",
      {
        url: getTeamUrl(teamId, viewLogsUrl(charger?.chargepoint_id)),
        // Including the filter query in the key makes react-query refetch from page 1
        // whenever a filter changes, so filtering happens server-side across all logs.
        search: logFilterQuery,
      },
    ],
    fetchInfinite,
    {
      enabled: !!charger && !hasTimeFilter && selectedTab === "logs" && !reduxData?.dataForLogs,
      // Live mode: auto-refresh so newest logs (idcms_logs DESC) keep flowing in.
      // Only polls while the tab is focused and the user hasn't paused it. Auto-stops
      // after LIVE_POLL_DURATION_MS (see the effect below) so we never poll forever.
      refetchInterval:
        !hasTimeFilter && livePolling && selectedTab === "logs" ? 15000 : false,
      refetchIntervalInBackground: false,
      getNextPageParam: (lastPage, pages) => {
        // If the last page is empty, there are no more pages
        if (lastPage.length === 0) {
          return undefined;
        }
        // Return the next page number
        return pages.length + 1;
      },
    }
  );

  // Live mode auto-refreshes (every 15s) for a bounded window only, then flips to the
  // paused state so we don't poll forever in the background. The user can click
  // Live / Resume to start the same 2-minute cycle again.
  const LIVE_POLL_DURATION_MS = 2 * 60 * 1000;
  useEffect(() => {
    if (hasTimeFilter || selectedTab !== "logs" || !livePolling) return undefined;
    const timer = setTimeout(() => setLivePolling(false), LIVE_POLL_DURATION_MS);
    return () => clearTimeout(timer);
  }, [livePolling, hasTimeFilter, selectedTab]);

  // Fetch real per-direction totals from the server whenever the content filters or the
  // active window change. messageType is intentionally omitted (the endpoint groups by
  // it), so both chip counts stay visible regardless of the selected direction.
  // Placed after selectedTab/teamId are declared to avoid a temporal-dead-zone error.
  useEffect(() => {
    if (!charger?.chargepoint_id || selectedTab !== "logs") return undefined;
    let cancelled = false;
    const params = new URLSearchParams();
    if (logFilters.connector && logFilters.connector !== "ALL")
      params.set("connector", logFilters.connector);
    if (Array.isArray(logFilters.action) && logFilters.action.length > 0)
      params.set("action", logFilters.action.join(","));
    if (logSearchDebounced && logSearchDebounced.trim() !== "")
      params.set("q", logSearchDebounced.trim());
    if (hasTimeFilter && logWindowParams) {
      params.set("startDate", logWindowParams.startDate);
      params.set("endDate", logWindowParams.endDate);
      params.set("startTime", logWindowParams.startTime);
      params.set("endTime", logWindowParams.endTime);
    }
    const qs = params.toString();
    const url = `${getTeamUrl(teamId, logsCountUrl(charger.chargepoint_id))}${
      qs ? `?${qs}` : ""
    }`;
    axios
      .get(url)
      .then((res) => {
        if (!cancelled && res?.data?.data) setLogCounts(res.data.data);
      })
      .catch(() => {
        if (!cancelled) setLogCounts({ total: 0, incoming: 0, outgoing: 0 });
      });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    charger?.chargepoint_id,
    teamId,
    selectedTab,
    logFilters.connector,
    Array.isArray(logFilters.action) ? logFilters.action.join(",") : "",
    logSearchDebounced,
    hasTimeFilter,
    logWindowParams,
  ]);

  // const handleTeamChange = (event) => {
  //   const selectedTeamId = event.target.value;
  //   setFieldValue("companyId", selectedTeamId); // Update the form's companyId field
  // };

  // // Filter the price groups based on the selected team's companyId
  // const filteredPriceGroups = priceGroups?.filter(
  //   (group) => group.companyId === values.companyId
  // );

  const handleRefetch = async () => {
    if (hasTimeFilter) {
      // If we have a time filter active, refresh the filtered data
      await fetchLogFilterData(timeInterval.startDate, timeInterval.endDate);
    } else {
      // Otherwise refetch the default real-time logs
      setSearchData(true);
      await refetch();
      setLogDetailData(logsData);
    }
  };

  const errorNotification = () => {
    return dispatch(
      setAlert({
        open: true,
        message: "Please select a valid time interval",
        severity: enums.SEVERITY.ERROR,
      })
    );
  };

  useEffect(() => {
    // Don't sync default logs when time-based logs are active
    if (logsData && !hasTimeFilter && !reduxData?.dataForLogs) {
      setLogDetailData(logsData);
    }
  }, [logsData?.pages?.length, hasTimeFilter, reduxData?.dataForLogs]); // Only update when pages change, not on every data update

  function getTime(time) {
    // Handle different time formats
    if (typeof time === "string") {
      // If it's an ISO string (UTC format), extract time from it
      if (time.includes("T") && (time.includes("Z") || time.includes("+"))) {
        // ISO format like "2025-09-24T05:33:18.619Z" or "2025-09-24T05:33:18+00:00"
        const date = new Date(time);
        return date.toLocaleTimeString("en-GB", { hour12: false }); // Format as HH:MM:SS
      }

      // If it's a space-separated format like "2025-09-24 05:33:18.619000"
      if (time.includes(" ")) {
        const timePart = time.split(" ")[1];
        if (timePart) {
          return timePart.split(".")[0]; // Remove milliseconds if present
        }
      }
    }

    // Fallback: treat as any date format and extract time
    let date = new Date(time);
    if (isNaN(date.getTime())) {
      return "00:00:00"; // Return default time if parsing fails
    }
    return date.toLocaleTimeString("en-GB", { hour12: false }); // Format as HH:MM:SS
  }

  const tabsToShow = useMemo(() => {
    // Operating Instruction is temporarily hidden (kept in ChargerFormTabs and
    // its TabPanel so it can be re-enabled later).
    const visible = ChargerFormTabs.filter(
      (tab) => tab.value !== "operating_instruction"
    );
    // An existing charger shows every (visible) tab; the create form hides the
    // ones that need a saved charger to act on.
    if (id) return visible;
    return visible.filter(
      (tab) =>
        tab.value !== "config" &&
        tab.value !== "logs" &&
        tab.value !== "remote operations" &&
        tab.value !== "report_incidents" &&
        tab.value !== "status_history"
    );
  }, [id]);

  const setSubmittingRef = useRef(null);
  const [connectorLengthErrors, setConnectorLengthErrors] = useState({});
  // Debounce timers (per connector index) for the MID / connector-name DB check.
  const midValidateTimers = useRef({});

  // Validate a connector name against the backend. A name longer than 6 chars is
  // only an error when it is NOT a MID found in the database (validate-mid).
  const validateConnectorName = useCallback(
    async (index, rawVal) => {
      const val = String(rawVal || "").trim();
      if (val.length <= 6) {
        setConnectorLengthErrors((prev) => {
          const next = { ...prev };
          delete next[index];
          return next;
        });
        return;
      }
      try {
        const chargerId = charger?.chargepoint_id || "";
        const params = new URLSearchParams({ connectorName: val });
        if (chargerId) params.append("chargerId", chargerId);
        const response = await axios.get(
          `${getTeamUrl(teamId, chargerUrl)}/validate-mid?${params.toString()}`
        );
        setConnectorLengthErrors((prev) => {
          const next = { ...prev };
          if (response?.data?.valid === true) {
            delete next[index];
          } else {
            next[index] = true;
          }
          return next;
        });
      } catch (_) {
        // On network/validation failure, fall back to the length-based error.
        setConnectorLengthErrors((prev) => ({ ...prev, [index]: true }));
      }
    },
    [charger?.chargepoint_id, teamId]
  );
  const { mutate, isLoading } = useMutate("chargers", {
    onCustomError: useCallback((error) => {
      setSubmittingRef.current?.(false);
      const raw =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        (typeof error === "string" ? error : "");
      let errorMessage;
      if (/connector name/i.test(raw) && /more than 3/i.test(raw)) {
        errorMessage = "Connector name is invalid. Use a name of 3 characters or fewer, or ensure a payment gateway with this name exists.";
      } else if (/no payment gateway/i.test(raw) || /key_id/i.test(raw)) {
        errorMessage = "No payment gateway found for this connector name. Add a matching gateway first.";
      } else if (/price group/i.test(raw)) {
        errorMessage = "Please assign a valid price group to each connector.";
      } else if (/duplicate/i.test(raw) || /already exists/i.test(raw)) {
        errorMessage = "A charger with this ID already exists. Use a different Charger ID.";
      } else if (/unauthorized/i.test(raw) || /forbidden/i.test(raw)) {
        errorMessage = "You do not have permission to perform this action.";
      } else {
        errorMessage = raw || "Failed to save charger data.";
      }
      dispatch(
        alertSlice.actions.setAlert({
          open: true,
          message: errorMessage,
          severity: enums.SEVERITY.ERROR,
        })
      );
    }, [dispatch]),
  });
  const { mutate: genQRMutate, isLoading: isGenQR } = useMutate("generateQR");
  // Which connector's Razorpay QR is generating, so only that connector's
  // Download button shows the busy state (isGenQR is a single form-wide flag).
  const [genQrConnectorPk, setGenQrConnectorPk] = useState(null);
  useEffect(() => {
    if (!isGenQR) setGenQrConnectorPk(null);
  }, [isGenQR]);
  const { modalOpen, remoteOperationPerformed, operationDetails } = useSelector(
    ({ remoteOpStatus }) => remoteOpStatus
  );
  const downloadUPIQRFromModal = (upiText, logoUrl) => {
    // This function will be called from the modal to download the QR code with logo
    const qrCode = document.getElementById(`upiqr-${upiText.replace(/[^a-zA-Z0-9]/g, '')}`);
    if (qrCode) {
      const svgElement = qrCode.querySelector("svg");
      if (svgElement) {
        const svgData = new XMLSerializer().serializeToString(svgElement);
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const img = new Image();
        img.onload = () => {
          const padding = 20;
          const widthWithPadding = img.width + padding * 2;
          const heightWithPadding = img.height + padding * 2;
          canvas.width = widthWithPadding;
          canvas.height = heightWithPadding;
          ctx.fillStyle = "#ffffff";
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(img, padding, padding);

          // Add logo overlay in the center if logoUrl is provided
          if (logoUrl) {
            const logoImg = new Image();
            logoImg.crossOrigin = "anonymous";
            logoImg.onload = () => {
              const logoSize = Math.min(img.width, img.height) * 0.2; // 20% of QR code size
              const logoX = padding + (img.width / 2) - (logoSize / 2);
              const logoY = padding + (img.height / 2) - (logoSize / 2);

              // Draw white background for logo
              ctx.fillStyle = "#ffffff";
              ctx.fillRect(logoX - 5, logoY - 5, logoSize + 10, logoSize + 10);

              // Draw logo
              ctx.drawImage(logoImg, logoX, logoY, logoSize, logoSize);

              // Download the final image
              const pngFile = canvas.toDataURL("image/jpeg");
              const downloadLink = document.createElement("a");
              downloadLink.download = "UPI_QR.jpeg";
              downloadLink.href = `${pngFile}`;
              downloadLink.click();
            };
            logoImg.onerror = () => {
              // If logo fails to load, download without logo
              const pngFile = canvas.toDataURL("image/jpeg");
              const downloadLink = document.createElement("a");
              downloadLink.download = "UPI_QR.jpeg";
              downloadLink.href = `${pngFile}`;
              downloadLink.click();
            };
            logoImg.src = logoUrl;
          } else {
            // Download without logo
            const pngFile = canvas.toDataURL("image/jpeg");
            const downloadLink = document.createElement("a");
            downloadLink.download = "UPI_QR.jpeg";
            downloadLink.href = `${pngFile}`;
            downloadLink.click();
          }
        };
        img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;
      }
    }
  };

  const [razorPayQRCodePreview, setRazorPayQRCodePreview] = useState({
    type: "payment",
    open: false,
    value: "",
    buttons: [
      {
        btnLabel: "Download",
        action: downloadRazorPayQR,
        params: true,
      },
      {
        btnLabel: "Close",
        action: function () {
          setRazorPayQRCodePreview({ ...razorPayQRCodePreview, open: false });
        },
      },
    ],
  });

  useEffect(() => {
    // Only process if we have transaction data, charger is loaded, and logs tab is selected
    if (reduxData?.dataForLogs && charger && selectedTab === "logs" && !hasAutoLoadedRef.current) {
      let startTime = reduxData.dataForLogs.starttime;
      let stopTime = reduxData.dataForLogs.stoptime
        ? reduxData.dataForLogs.stoptime
        : new Date(); // Use Date object directly, not formatted string



      // Convert string dates to Date objects for the time interval state (for display)
      let startDate = "";
      let endDate = "";

      if (startTime) {
        startDate = parseDateTimeString(startTime);
      }

      if (stopTime) {
        endDate = parseDateTimeString(stopTime);
      } else {
        // Fallback if stopTime became null/undefined somehow (shouldn't happen due to logic above)
        endDate = new Date();
      }

      setTimeInterval((prev) => ({ startDate, endDate }));

      // Don't auto-load if user is actively selecting dates
      if (!isDateInputFocused) {
        // Mark as loaded before calling to prevent duplicate calls
        hasAutoLoadedRef.current = true;
        // Set time filter as active when time is prepopulated
        setHasTimeFilter(true);
        // Pass Date objects for API call - fetchLogFilterData will handle UTC conversion
        fetchLogFilterData(startDate, endDate);
      }
    }
  }, [reduxData, selectedTab, charger, isDateInputFocused]);

  // Reset auto-load flag when tab changes or when transaction data changes
  useEffect(() => {
    hasAutoLoadedRef.current = false;
    // Clear any pending blur timeout when tab changes
    if (dateInputBlurTimeoutRef.current) {
      clearTimeout(dateInputBlurTimeoutRef.current);
      dateInputBlurTimeoutRef.current = null;
    }
  }, [selectedTab, reduxData?.dataForLogs]);

  // Automatically load logs when logs tab is selected (fallback for non-transaction cases)
  useEffect(() => {
    // Don't auto-load if user is actively selecting dates or if we've already loaded
    if (isDateInputFocused || hasAutoLoadedRef.current) {
      return;
    }

    // Skip if transaction data exists (handled by the above useEffect)
    if (reduxData?.dataForLogs) {
      return;
    }

    if (selectedTab === "logs" && charger) {
      // If there's already a time interval set, automatically fetch logs
      if (timeInterval.startDate && timeInterval.endDate) {
        // Set time filter as active when time interval is already set
        setHasTimeFilter(true);
        fetchLogFilterData(timeInterval.startDate, timeInterval.endDate);
        hasAutoLoadedRef.current = true;
      } else {
        // Otherwise, just refetch the default logs (without time filter)
        refetch();
        hasAutoLoadedRef.current = true;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedTab,
    charger,
    refetch,
    reduxData,
    isDateInputFocused,
    timeInterval.startDate,
    timeInterval.endDate,
  ]);

  // Helper function to format date in UTC (yyyy-MM-dd)
  const formatDateAsUTC = (date) => {
    if (!date || !(date instanceof Date) || isNaN(date.getTime())) {
      return "";
    }
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const fetchLogFilterData = async (sDate, eDate) => {
    // Convert input dates to proper format for API
    let startDate = "";
    let endDate = "";
    let timeStart = "00:00:00";
    let timeEnd = "00:00:00";

    // If endDate is not provided but startDate is, use current time as endDate
    let effectiveEndDate = eDate;

    // Enforce the max 1-day (24h) window on the client, with clear feedback. The API
    // also rejects a longer range, but that error is otherwise swallowed below.
    const startForCheck = sDate ? new Date(sDate) : null;
    const endForCheck = eDate ? new Date(eDate) : new Date();
    if (startForCheck && !Number.isNaN(startForCheck.getTime())) {
      const diffHours = (endForCheck - startForCheck) / (1000 * 60 * 60);
      if (diffHours < 0) {
        dispatch(
          setAlert({
            open: true,
            message: "End time must be after start time",
            severity: enums.SEVERITY.ERROR,
          })
        );
        return;
      }
      if (diffHours > 24) {
        dispatch(
          setAlert({
            open: true,
            message: "Log range must not exceed 1 day (24 hours)",
            severity: enums.SEVERITY.ERROR,
          })
        );
        return;
      }
    }

    if (sDate && sDate !== "" && (!eDate || eDate === "")) {
      effectiveEndDate = new Date(); // Use current time
    }

    if (sDate && sDate !== "") {
      // Convert local time to UTC for API - use UTC date to handle day rollover correctly
      // For example: 4:07 AM IST Jan 27 = 10:37 PM UTC Jan 26
      startDate = formatDateAsUTC(sDate);
      const utcHours = sDate.getUTCHours().toString().padStart(2, "0");
      const utcMinutes = sDate.getUTCMinutes().toString().padStart(2, "0");
      const utcSeconds = "00"; // Set seconds to 00 for logs API
      timeStart = `${utcHours}:${utcMinutes}:${utcSeconds}`;
    } else if (effectiveEndDate && effectiveEndDate !== "") {
      const endDateObj = effectiveEndDate;
      startDate = formatDateAsUTC(endDateObj);
    }

    if (effectiveEndDate && effectiveEndDate !== "") {
      // Convert local time to UTC for API - use UTC date to handle day rollover correctly
      endDate = formatDateAsUTC(effectiveEndDate);

      const utcHours = effectiveEndDate
        .getUTCHours()
        .toString()
        .padStart(2, "0");
      const utcMinutes = effectiveEndDate
        .getUTCMinutes()
        .toString()
        .padStart(2, "0");
      const utcSeconds = "00"; // Set seconds to 00 for logs API
      timeEnd = `${utcHours}:${utcMinutes}:${utcSeconds}`;

    }

    if (
      startDate &&
      endDate &&
      isValidTimeInterval({ start: startDate, end: endDate })
    ) {
      setSearchData(false);
      setIsFetchingLogs(true);
      setLogDetailData({ pages: [] });
      // Remember the UTC window so the COUNT endpoint can use the same bounds.
      setLogWindowParams({ startDate, endDate, startTime: timeStart, endTime: timeEnd });

      try {
        const baseUrl = logFilterData(
          teamId,
          charger.chargepoint_id,
          startDate,
          endDate,
          timeStart,
          timeEnd
        );
        // logFilterData already has a query string, so append the content filters
        // with "&" (logFilterQuery starts with "?").
        const url = logFilterQuery
          ? `${baseUrl}&${logFilterQuery.slice(1)}`
          : baseUrl;
        const response = await axios.get(url);
        if (response.data) {
          setLogDetailData((prev) => ({
            ...prev,
            pages: [response.data.data],
          }));
        }
      } catch (error) {
        // Error handled silently
      } finally {
        setIsFetchingLogs(false);
      }
    } else errorNotification();
  };

  // Apply a "last N minutes" quick range: fetches that fixed window (no auto-refresh).
  const applyLogRange = (minutes) => {
    const end = new Date();
    const start = new Date(end.getTime() - minutes * 60 * 1000);
    setLogRangePreset(String(minutes));
    setTimeInterval({ startDate: start, endDate: end });
    setHasTimeFilter(true);
    // Prevent the auto-load effect from re-fetching a different range.
    hasAutoLoadedRef.current = true;
    fetchLogFilterData(start, end);
  };

  // Switch back to Live mode: clear the time window and resume the auto-refreshing
  // real-time query (also clears any redux-provided window that would disable it).
  const goLive = () => {
    setLogRangePreset("LIVE");
    setHasTimeFilter(false);
    setTimeInterval({ startDate: "", endDate: "" });
    setLogDetailData(null);
    setLogWindowParams(null);
    setLivePolling(true);
    hasAutoLoadedRef.current = true;
    if (reduxData?.dataForLogs) {
      const newReduxData = { ...reduxData };
      delete newReduxData.dataForLogs;
      dispatch(
        tabsCurrentlyOpenedForSlice.actions.setTabsOpened({
          detailsId: charger?.chargepoint_id,
          tabOpenedFor,
          tabOpened,
          data: newReduxData,
        })
      );
    }
    refetch();
  };

  // In time-filter mode, re-run the server query when a content filter changes so the
  // filter is applied across the whole selected window (server-side), not just the
  // rows already on screen.
  useEffect(() => {
    if (hasTimeFilter && timeInterval.startDate) {
      fetchLogFilterData(timeInterval.startDate, timeInterval.endDate);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [logFilterQuery]);

  const [CMQRCodePreview, setCMQRCodePreview] = useState({
    type: "charger",
    open: false,
    templateVal: `${domainConfig.mapUrl}/charger/`,
    value: "",
    buttons: [
      {
        btnLabel: "Download",
        action: downloadCMQR,
        params: true,
      },
      {
        btnLabel: "Close",
        action: function () {
          setCMQRCodePreview({ ...CMQRCodePreview, open: false });
        },
      },
    ],
  });

  const hasConnectorsAdded = useCallback((connectors = []) => {
    return connectors.some(
      (connector) =>
        (connector.volt !== "" && connector.connectorType !== "") ||
        (connector.kw !== "" && connector.connectorType !== "")
    );
  }, []);

  const handleRemoteOpsStatusModalClose = () => {
    dispatch(
      remoteOpsStatusSlice.actions.setRemoteOps({
        open: false,
        remoteOperationPerformed: null,
        operationDetails: { chargerId: null, response: null },
      })
    );
  };

  const onSubmit = async (chargerData, { setSubmitting: _setSubmitting }) => {
    const setSubmitting = (val) => {
      setSubmittingRef.current = null;
      _setSubmitting(val);
    };
    setSubmittingRef.current = _setSubmitting;

    // If any connector still has a length error, validate against PG before submitting
    const errorIndices = Object.keys(connectorLengthErrors);
    if (errorIndices.length > 0) {
      const chargerId = charger?.chargepoint_id || "";
      const results = await Promise.all(
        errorIndices.map(async (i) => {
          const connectorName = chargerData.connectors?.[i]?.connectorName;
          if (!connectorName || String(connectorName).trim().length <= 6) return true;
          try {
            const params = new URLSearchParams({ connectorName: connectorName.trim() });
            if (chargerId) params.append("chargerId", chargerId);
            const response = await axios.get(
              `${getTeamUrl(teamId, chargerUrl)}/validate-mid?${params.toString()}`
            );
            if (response?.data?.valid === true) {
              setConnectorLengthErrors((prev) => { const next = { ...prev }; delete next[i]; return next; });
              return true;
            }
            return false;
          } catch (_) {
            return false;
          }
        })
      );
      if (results.some((valid) => !valid)) {
        setSubmitting(false);
        return; // inline errors already visible
      }
    }

    let hasConnectors = !0;
    const {
      actions: { setAlert },
    } = alertSlice;

    // Ensure isActive cannot be disabled once enabled
    if (charger?.status === "A" && !chargerData.isActive) {
      chargerData.isActive = true;
    }
    const {
      street,
      houseNumber,
      zipcode,
      city,
      country,
      state,
      connectors,
      locationLatitude,
      locationLongitude,
    } = chargerData;

    // Convert string coordinates to numbers for API submission
    const finalLat = parseFloat(locationLatitude);
    const finalLng = parseFloat(locationLongitude);

    if (isNaN(finalLat) || isNaN(finalLng)) {
      dispatch(
        setAlert({
          open: true,
          message: "Address is required for the Charge Point",
          severity: enums.SEVERITY.ERROR,
        })
      );
      setSubmitting(false);
      return;
    }
    chargerData.address = {
      street,
      houseNumber,
      zipcode,
      city,
      country,
      state,
    };
    chargerData.locationLatitude = finalLat;
    chargerData.locationLongitude = finalLng;
    chargerData.employeeOrResident = Number(chargerData.employeeOrResident);
    chargerData.payWithWallet = Number(chargerData.payWithWallet);
    chargerData.payWithCard = Number(chargerData.payWithCard);
    // Ensure isActive value is preserved and not changed once enabled
    chargerData.isActive = Boolean(chargerData.isActive);
    // Set charger_category based on showOnPortal value
    // If showOnPortal is true, set to "paid", otherwise keep existing value or set to "free"
    // if (chargerData.showOnPortal) {
    //   chargerData.charger_category = "paid";
    // } else if (!chargerData.charger_category) {
    //   chargerData.charger_category = "free";
    // }
    chargerData.notificationSettings = {
      notificationRecipients: chargerData.notificationRecipients,
      whatsappPhone: chargerData.whatsappPhone || null,
      enableNotifications: Number(chargerData.enableNotifications),
      OcppStationBooted: Number(chargerData.OcppStationBooted),
      OcppStationStatusFailure: Number(chargerData.OcppStationStatusFailure),
      OcppStationWebSocketConnected: Number(
        chargerData.OcppStationWebSocketConnected
      ),
      OcppStationWebSocketDisconnected: Number(
        chargerData.OcppStationWebSocketDisconnected
      ),
      OcppTransactionStarted: Number(chargerData.OcppTransactionStarted),
      OcppTransactionEnded: Number(chargerData.OcppTransactionEnded),
    };
    const mutateObject = {
      url: getTeamUrl(teamId, chargerUrl),
      method: "POST",
    };
    if (!is.nullOrUndefined(id) && !isCreateCharger) {
      // update charger point if id is undefined
      mutateObject.method = "PUT";
      mutateObject.url = getTeamUrl(teamId, chargerIdUrl(id));
    }

    if (connectors.length === 1) {
      hasConnectors = hasConnectorsAdded(connectors);
      if (!hasConnectors) {
        dispatch(
          setAlert({
            open: true,
            message: "At least 1 connector is required",
            severity: enums.SEVERITY.ERROR,
          })
        );
        setSubmitting(false);
        return;
      }
    }

    if (connectors.length > 0 && hasConnectors) {
      const arePricegroupsPresent = connectors.every(
        ({ priceGroupId }) => !is.empty(priceGroupId)
      );
      if (!arePricegroupsPresent) {
        //TO CHECK WHETHER ALL THE CONNECTORS HAVE A PRICEGROUP SELECTED
        dispatch(
          setAlert({
            open: true,
            message:
              "Every connector should have a pricegroup specified for it",
            severity: enums.SEVERITY.ERROR,
          })
        );
        setSubmitting(false);
        return;
      }
      // Validate connector numeric fields before submit
      const invalidConnector = connectors.find((connector, idx) => {
        if (connector.kw !== "" && connector.kw !== null && connector.kw !== undefined) {
          const kwNum = Number(connector.kw);
          if (isNaN(kwNum) || kwNum < 0) return true;
        }
        if (connector.volt !== "" && connector.volt !== null && connector.volt !== undefined) {
          const voltNum = Number(connector.volt);
          if (isNaN(voltNum) || voltNum < 0) return true;
        }
        return false;
      });
      if (invalidConnector) {
        dispatch(
          setAlert({
            open: true,
            message: "Connector kW and Voltage must be valid numbers (e.g. 7.4, not \"7.4.0\")",
            severity: enums.SEVERITY.ERROR,
          })
        );
        setSubmitting(false);
        return;
      }

      chargerData.connectors = connectors.map((connector, index) => {
        if (!connector?.connectorName) {
          connector["connectorName"] = index + 1;
        }
        return { ...connector, connectorId: index + 1 };
      });
    }

    chargerData.photos = !is.empty(chargerData.photos)
      ? chargerData.photos.filter((photo) => !is.empty(photo))
      : [];
    chargerData.amenities = !is.empty(chargerData.amenities)
      ? chargerData.amenities.filter((amenity) => !is.empty(amenity))
      : [];
    chargerData.tags = !is.empty(chargerData.tags)
      ? chargerData.tags
          .map((t) => (typeof t === "string" ? t.trim() : t))
          .filter((t) => !is.empty(t))
      : [];
    chargerData.chargepoint_id = chargerData.chargepoint_id.trim();
    // OCPP auth fields are sent as-is and left in the form state (chargerData IS the
    // Formik values object — deleting from it would break a resubmit after a failed
    // save). The API ignores an empty password (keeps the stored one), ignores the
    // password entirely with "No authentication", and ignores hasOcppAuthPassword.
    mutate(
      {
        url: mutateObject.url,
        method: mutateObject.method,
        body: chargerData,
      },
      {
        onSuccess: (data) => {
          setSubmitting(false);
          dispatch(
            tabsCurrentlyOpenedForSlice.actions.setTabsOpened({
              detailsId: "",
              tabOpenedFor: "",
              tabOpened: "",
              data: {},
            })
          );
          navigate("/charger");
        },
      }
    );
  };

  // Prepare initial values based on whether we're editing or creating
  const getInitialValues = () => {
    if (charger && !isCreateCharger) {
      // For edit mode, use charger data
      const {
        address,
        notificationSettings,
        employeeOrResident,
        payWithWallet,
        payWithCard,
        status,
        connectors,
        ...rest
      } = charger;
      const { zipcode } = address;

      const updatedConnectors = connectors.map((connector) => ({
        ...connector,
        // Offline charger: a stale Available / in-use status shows as Offline; others
        // (Faulted, Unavailable, …) as stored.
        status: status === "NA" ? connectorStatusWhenOffline(connector.status) : connector.status,
      }));

      const visibiltyOnPortal = !!charger.showOnPortal;
      const preparingState = !!charger.preparingState;

      let formValues = {
        ...rest,
        ...address,
        showOnPortal: visibiltyOnPortal,
        preparingState: preparingState,
        zipcode: zipcode,
        employeeOrResident: !!employeeOrResident,
        payWithWallet: !!payWithWallet,
        payWithCard: !!payWithCard,
        status: status === "A" ? "Active" : "Inactive",
        isActive: status === "A",
        connectors: updatedConnectors,
        charger_category: charger.charger_category || "paid",
        access_level: charger.access_level || "Public",
        photos: charger.photos || [],
        tags: charger.tags || [],
        tolerance_watt: charger.tolerance_watt || 300,
        meter_interval_sec: charger.meter_interval_sec || 30,
        tolerance_updated_at: charger.tolerance_updated_at || null,
        // The API never returns the password — only whether one is set. The field
        // starts empty; leaving it empty keeps the stored password.
        ocpp_auth_mode: charger.ocpp_auth_mode || "NONE",
        ocpp_auth_password: "",
        hasOcppAuthPassword: Boolean(charger.hasOcppAuthPassword),
      };

      // Handle notification settings
      if (notificationSettings) {
        const {
          settings_pk,
          enableNotifications,
          notificationFeatures,
          notificationRecipients,
          whatsappPhone,
        } = notificationSettings;

        let allNotificationFeatures;
        if (!is.empty(notificationFeatures)) {
          const selectedFeatures = notificationFeatures.split(",");
          allNotificationFeatures = NOTIFICATION_CONSTANTS.reduce(
            (allNotificationFeatures, feature) => {
              allNotificationFeatures = {
                ...allNotificationFeatures,
                [feature]: false,
              };
              if (selectedFeatures.includes(feature)) {
                allNotificationFeatures[feature] = true;
              }
              return allNotificationFeatures;
            },
            {}
          );
        } else {
          allNotificationFeatures = NOTIFICATION_CONSTANTS.reduce(
            (allNotificationFeatures, feature) => {
              allNotificationFeatures = {
                ...allNotificationFeatures,
                [feature]: false,
              };
              return allNotificationFeatures;
            },
            {}
          );
        }

        formValues = {
          ...formValues,
          ...allNotificationFeatures,
          settings_pk,
          notificationRecipients,
          whatsappPhone: whatsappPhone || "",
          enableNotifications: !!enableNotifications,
        };
      } else {
        formValues = {
          ...formValues,
          enableNotifications: false,
          notificationRecipients: "",
          whatsappPhone: "",
          OcppStationBooted: false,
          OcppStationStatusFailure: false,
          OcppStationWebSocketConnected: false,
          OcppStationWebSocketDisconnected: false,
          OcppTransactionStarted: false,
          OcppTransactionEnded: false,
        };
      }

      return formValues;
    }
    // For create mode, use default values
    return getChargerDefaultValues({ teamId });
  };

  const formik = useFormik({
    initialValues: getInitialValues(),
    validationSchema: chargerFormValidationSchema,
    onSubmit: onSubmit,
    enableReinitialize: true,
    validateOnMount: false,
    validateOnChange: false,
    validateOnBlur: false,
  });

  const {
    errors,
    touched,
    values,
    handleSubmit,
    isSubmitting,
    getFieldProps,
    resetForm,
    setFieldValue,
  } = formik;

  // Whether the charger's company has WhatsApp notifications enabled (set per
  // company by a super admin). Gates the WhatsApp phone field in Notifications.
  const [whatsappEnabled, setWhatsappEnabled] = useState(false);
  useEffect(() => {
    let active = true;
    const cid = values.companyId || charger?.companyId;
    if (!cid) {
      setWhatsappEnabled(false);
      return undefined;
    }
    (async () => {
      const cfg = await whatsappService.getCompanyWhatsappConfig(cid);
      if (active) setWhatsappEnabled(cfg?.whatsappEnabled === true);
    })();
    return () => {
      active = false;
    };
  }, [values.companyId, charger?.companyId]);

  const connectorOptions = useMemo(
    () =>
      (values.connectors || []).map((connector, index) => {
        const connectorId = String(
          connector.connectorId || connector.connector_id || connector.id || index + 1
        );
        const parts = [`Connector ${connectorId}`];
        if (connector.connectorName) parts.push(connector.connectorName);
        else if (connector.connectorType) parts.push(connector.connectorType);
        if (connector.kw) parts.push(`${connector.kw} kW`);
        return { connectorId, label: parts.join(" · ") };
      }),
    [values.connectors]
  );

  const fetchConnectorStatusHistory = useCallback(
    async (connectorId, page = 0, pageSize = 10) => {
      const chargerId = charger?.chargepoint_id || id;
      if (!chargerId || !connectorId) {
        setStatusHistoryError("Charger or connector ID is unavailable.");
        return;
      }

      try {
        Token.setAuthToken();
        setStatusHistoryLoading(true);
        setStatusHistoryError("");
        setStatusHistory([]);

        const response = await axios.get(
          `/cms/v1/connector/status-history/charger/${encodeURIComponent(
            chargerId
          )}/connector/${encodeURIComponent(connectorId)}`,
          { params: { page: page + 1, limit: pageSize } }
        );

        const history = response?.data?.data || response?.data || [];
        const total =
          response?.data?.pagination?.total ??
          response?.data?.total ??
          (Array.isArray(history) ? history.length : 0);
        setStatusHistory(Array.isArray(history) ? history : []);
        setStatusHistoryTotal(total);
      } catch (error) {
        console.error("Error fetching connector status history:", error);
        setStatusHistoryError(
          error?.message || "Failed to fetch status history."
        );
      } finally {
        setStatusHistoryLoading(false);
      }
    },
    [charger, id]
  );

  const handleStatusHistoryConnectorChange = useCallback((event) => {
    const newConnectorId = event.target.value;
    setStatusHistoryConnectorId(newConnectorId);
    setStatusHistoryPage(0);
    setStatusHistory([]);
    setStatusHistoryError("");
  }, []);

  useEffect(() => {
    if (selectedTab !== "status_history" || connectorOptions.length === 0) {
      return;
    }

    const connectorId =
      statusHistoryConnectorId || connectorOptions[0]?.connectorId;
    if (!connectorId) {
      return;
    }

    if (!statusHistoryConnectorId) {
      setStatusHistoryConnectorId(connectorId);
      return;
    }

    fetchConnectorStatusHistory(connectorId, statusHistoryPage, statusHistoryPageSize);
  }, [selectedTab, connectorOptions, statusHistoryConnectorId, statusHistoryPage, statusHistoryPageSize, fetchConnectorStatusHistory]);

  // Helper function to determine if validation errors should be shown
  const shouldShowError = (fieldName) => {
    // Only show errors if field has been touched or form is submitting
    return (touched[fieldName] || isSubmitting) && errors[fieldName];
  };

  // Helper function to determine if form-level errors should be shown
  const shouldShowFormErrors = () => {
    // Only show errors if any field has been touched or form is submitting
    return (
      (Object.keys(touched).length > 0 || isSubmitting) &&
      Object.keys(errors).length > 0
    );
  };

  // Tolerance and meter interval are now manually entered.
  // Auto-calculation is handled by the websocket server on BootNotification / SetConfiguration events.

  // Manual validation trigger for field changes
  const handleFieldChange = (fieldName, value) => {
    setFieldValue(fieldName, value);
    // Trigger validation for this field
    formik.validateField(fieldName);
  };

  // Reset form when charger data is loaded
  useEffect(() => {
    if (charger && !isCreateCharger) {
      const initialValues = getInitialValues();
      resetForm({
        values: initialValues,
        errors: {},
        touched: {},
      });
    }
  }, [charger, isCreateCharger, resetForm]);

  // Prevent isActive from being disabled once enabled
  useEffect(() => {
    if (values && values.isActive === false && charger?.status === "A") {
      // If the charger is active on the server but form shows inactive, correct it
      setFieldValue("isActive", true);
    }
  }, [values?.isActive, charger?.status, setFieldValue]);

  const handleAddAndDeleteConnectors = (key = null) => {
    const { connectors } = values;
    if (is.null(key) && connectors.length !== 4) {
      setFieldValue("connectors", connectors.concat(initialConnectors));
    }
    if (!is.null(key)) {
      setFieldValue(
        "connectors",
        connectors.filter((c, i) => i !== key)
      );
    }
  };

  const handleAddAndDeleteFAQ = (key = null) => {
    const { faq } = values;
    if (is.null(key) && faq.length !== 10) {
      setFieldValue("faq", faq.concat(initialFaq));
    }

    if (!is.null(key)) {
      setFieldValue(
        "faq",
        faq.filter((c, i) => i !== key)
      );
    }
  };

  const handleShowRazorPayQRCode = (QRCodeUrl) => {
    // Check if QRCodeUrl starts with "upi://"
    const isUPIProtocol = QRCodeUrl && typeof QRCodeUrl === 'string' && QRCodeUrl.startsWith('upi://');

    // Get logo URL from domain config
    const logoUrl = domainConfig?.logoUrl || '/logo/amikCharge.svg';
    const fullLogoUrl = logoUrl.startsWith('http')
      ? logoUrl
      : `${window.location.origin}${logoUrl.startsWith('/') ? logoUrl : '/' + logoUrl}`;

    const updatedPreviewObject = {
      ...razorPayQRCodePreview,
      value: QRCodeUrl,
      type: isUPIProtocol ? "upi" : "payment",
      logoUrl: isUPIProtocol ? fullLogoUrl : undefined, // Only add logo for UPI QR codes
      open: true,
    };
    setRazorPayQRCodePreview(updatedPreviewObject);
  };

  const handleShowCMQRCode = (chargerId) => {
    const updatedPreviewObject = {
      ...CMQRCodePreview,
      value: chargerId,
      open: true,
    };
    setCMQRCodePreview(updatedPreviewObject);
  };

  const generateQRCode = (connectorId) => {
    genQRMutate(
      {
        url: getTeamUrl(
          teamId,
          `/charger/${charger?.chargepoint_id}/generateQr`
        ),
        method: "POST",
        body: { connectorId, companyId: charger.companyId },
      },
      { onSuccess: () => queryClient.invalidateQueries("charger") }
    );
  };

  // Address tab helper functions
  const imageUploadInputRef = useRef();
  const imgUpload = useMutation(issueImgUpload);
  const [imageUploadPending, setImageUploadPending] = useState(false);
  const [isGeocodingAddress, setIsGeocodingAddress] = useState(false);

  const autoFetchTrigerredRef = useRef(false);
  const geocodingTimerRef = useRef(null);

  // ── REVERSE GEOCODE ON LAT/LNG CHANGE ──
  useEffect(() => {
    const lat = values.locationLatitude;
    const lng = values.locationLongitude;

    // Need both values with reasonable length (at least 4 chars like "17.4")
    if (!lat || !lng || lat.toString().length < 4 || lng.toString().length < 4) return;

    const latNum = parseFloat(lat);
    const lngNum = parseFloat(lng);
    if (isNaN(latNum) || isNaN(lngNum) || latNum < -90 || latNum > 90 || lngNum < -180 || lngNum > 180) return;

    // Debounce: wait 800ms after last keystroke
    if (geocodingTimerRef.current) clearTimeout(geocodingTimerRef.current);

    // Show loading animation
    setIsGeocodingAddress(true);

    geocodingTimerRef.current = setTimeout(() => {
      const doGeocode = () => {
        if (!window.google || !window.google.maps || !window.google.maps.Geocoder) {
          setTimeout(doGeocode, 500);
          return;
        }

        const geocoder = new window.google.maps.Geocoder();
        const latLng = new window.google.maps.LatLng(latNum, lngNum);

        geocoder.geocode({ location: latLng }, (results, status) => {
          setIsGeocodingAddress(false);
          if (status === "OK" && results && results.length > 0) {
            const primary = results[0];
            const parsed = parseGoogleAddress(primary.address_components, primary.formatted_address);

            if (parsed) {
              setFieldValue("street", parsed.street);
              setFieldValue("city", parsed.city);
              setFieldValue("state", parsed.state);
              setFieldValue("country", parsed.country);
              
              // If zip not found in primary result, search remaining results
              let zipcode = parsed.zipCode;
              if (!zipcode) {
                for (let i = 1; i < results.length; i++) {
                  const comps = results[i].address_components || [];
                  for (let comp of comps) {
                    if (comp.types.includes("postal_code")) {
                      zipcode = comp.long_name;
                      break;
                    }
                  }
                  if (zipcode) break;
                }
              }
              setFieldValue("zipcode", zipcode);

              // Also update the map search bar
              const input = document.getElementById("places");
              if (input) input.value = parsed.street;
            }
          }
        });
      };

      doGeocode();
    }, 800);

    return () => {
      if (geocodingTimerRef.current) clearTimeout(geocodingTimerRef.current);
    };
  }, [values.locationLatitude, values.locationLongitude, setFieldValue]);

  useEffect(() => {
    if (isCreateCharger || !charger || autoFetchTrigerredRef.current) return;
    
    // We only want to trigger this if the charger's original address is missing parts
    const { 
      city, state, country 
    } = charger.address || {};
    const zipcode = charger.address?.zipcode || charger.address?.zipCode;
    const lat = charger.locationLatitude;
    const lng = charger.locationLongitude;

    if (lat && lng && (!city || !state || !zipcode || !country)) {
      autoFetchTrigerredRef.current = true;
      const fetchAddress = () => {
        if (window.google && window.google.maps && window.google.maps.Geocoder) {
          const geocoder = new window.google.maps.Geocoder();
          const latLng = new window.google.maps.LatLng(parseFloat(lat), parseFloat(lng));
          
          geocoder.geocode({ location: latLng }, (results, status) => {
            if (status === "OK" && results[0]) {
              const parsed = parseGoogleAddress(results[0].address_components, results[0].formatted_address);
              if (parsed) {
                if (!country) setFieldValue("country", parsed.country);
                if (!city) setFieldValue("city", parsed.city);
                if (!state) setFieldValue("state", parsed.state);
                
                let zipcodeValue = parsed.zipCode;
                // Double check for zip in other results if missing
                if (!zipcodeValue) {
                    for (let i = 1; i < results.length; i++) {
                        const comps = results[i].address_components || [];
                        const zipComp = comps.find(c => c.types.includes("postal_code"));
                        if (zipComp) {
                            zipcodeValue = zipComp.long_name;
                            break;
                        }
                    }
                }
                if (!zipcode && zipcodeValue) setFieldValue("zipcode", zipcodeValue);
              }
            } else {
                console.error("Geocoder failed due to: " + status);
            }
          });
        } else {
          // Try again in 500ms
          setTimeout(fetchAddress, 500);
        }
      };
      
      fetchAddress();
    }
  }, [isCreateCharger, charger, setFieldValue]);

  const handlePlacesChanged = (places) => {
    const {
      address_components,
      geometry: { location },
      formatted_address,
    } = places[0];
    
    // Clear out previous values in case the new place doesn't have them
    setFieldValue("country", "");
    setFieldValue("city", "");
    setFieldValue("state", "");
    setFieldValue("zipcode", "");

    const parsed = parseGoogleAddress(address_components, formatted_address);
    if (parsed) {
      setFieldValue("country", parsed.country);
      setFieldValue("city", parsed.city);
      setFieldValue("state", parsed.state);
      setFieldValue("zipcode", parsed.zipCode);
      setFieldValue("street", parsed.street);
      
      // If zip not found in primary result, do a deeper geocode lookup
      if (!parsed.zipCode && window.google && window.google.maps) {
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode(
          { location: { lat: location.lat(), lng: location.lng() } },
          (results, status) => {
            if (status === "OK" && results) {
              for (let result of results) {
                for (let comp of (result.address_components || [])) {
                  if (comp.types.includes("postal_code")) {
                    setFieldValue("zipcode", comp.long_name);
                    return;
                  }
                }
              }
            }
          }
        );
      }
      
      setFieldValue("locationLatitude", location.lat());
      setFieldValue("locationLongitude", location.lng());
    }
  };

  const handleAmenitiesChange = (event) => {
    const {
      target: { value },
    } = event;
    setFieldValue(
      "amenities",
      typeof value === "string" ? value.split(",") : value
    );
  };

  const handleImageUpload = async (e) => {
    const files = e.target.files;
    const base64 = [];
    setImageUploadPending(true);
    for (let file of files) {
      base64.push(await fileToBase64(file));
    }

    base64.forEach((b) => {
      imgUpload.mutate(
        {
          image: b,
        },
        {
          onSuccess: (response) => {
            setImageUploadPending(false);
            const photos = values.photos.concat([response.data.data]);
            setFieldValue("photos", photos);
          },
          onError: (error) => {
            console.error("ChargerForm: Error uploading image:", {
              error: error.message,
              stack: error.stack,
              chargepoint_id: values.chargepoint_id,
            });
            setImageUploadPending(false);
            dispatch(
              alertSlice.actions.setAlert({
                open: true,
                message: "Failed to upload image",
                severity: enums.SEVERITY.ERROR,
              })
            );
          },
        }
      );
    });
  };

  // Handle Redux state updates when charger data changes
  useEffect(() => {
    if (charger && priceGroups) {
      const { status, connectors } = charger;

      // update connector status for Inactive Chargers
      const updatedConnectors = connectors.map((connector) => ({
        ...connector,
        // Offline charger: a stale Available / in-use status shows as Offline; others
        // (Faulted, Unavailable, …) as stored.
        status: status === "NA" ? connectorStatusWhenOffline(connector.status) : connector.status,
      }));
      // Preserve existing dataForLogs result!
      const currentDataForLogs = reduxData?.dataForLogs;
      const updatedReduxData = { 
        ...charger, 
        connectors: updatedConnectors, 
        dataForLogs: currentDataForLogs 
      };
      
      // Only dispatch if something actually changed
      if (JSON.stringify(reduxData) !== JSON.stringify(updatedReduxData)) {
         dispatch(
          tabsCurrentlyOpenedForSlice.actions.setTabsOpened({
            detailsId: charger.chargepoint_id,
            tabOpenedFor: "charger",
            tabOpened,
            data: updatedReduxData,
          })
        );
      }
    }
  }, [charger, priceGroups, dispatch, tabOpened]);

  const handleTabChange = (e, tab) => {
    setSelectedTab(tab);
  };

  /*
  REMOTE OPERATIONS ESSENTIALS
  */
  const [operation, setOperation] = useState("ChangeAvailability");

  const validationSchema = useMemo(() => {
    const schema =
      remoteOperationConfig[operation]?.reduce(createYupSchema, {}) ?? {};
    return operation && Yup.object().shape(schema);
  }, [operation]);

  const initialValues = useMemo(() => {
    const values =
      remoteOperationConfig[operation]?.reduce(
        (acc, { fieldName, value }) => ({ ...acc, [fieldName]: value ?? "" }),
        {}
      ) ?? {};
    return values;
  }, [operation]);

  const queryKeysDropdown = useMemo(() => {
    const values =
      remoteOperationConfig[operation]?.reduce(
        (acc, { queryKey, usePk, useEmail }) => {
          return queryKey ? [...acc, { queryKey, usePk, useEmail }] : acc;
        },
        []
      ) ?? [];
    return values;
  }, [operation]);

  // Handle navigation when charger is not found
  useEffect(() => {
    if (!isFetching && !isCreateCharger && is.empty(charger) && !!teamId && !chargerError) {
      if (charger === "") {
         navigate("/dashboard");
      }
    }
  }, [isFetching, isCreateCharger, charger, teamId, chargerError, navigate]);

  if (isChargerLoading && !isCreateCharger) {
    return <Loader />;
  }

  if (!isCreateCharger && is.empty(charger)) {
    return null;
  }

  function convertArrayOfObjectsToCSV(arrayOfObjects) {
    if (
      !arrayOfObjects ||
      !Array.isArray(arrayOfObjects) ||
      arrayOfObjects.length === 0
    ) {
      return "";
    }
    const csvContent = arrayOfObjects.map((objects) => {
      const rows = objects.map((object) => {
        const values = Object.values(object).map((value) => `"${value}"`);
        return values.join("; ");
      });
      return rows.join("\n");
    });

    return csvContent.join("\n\n");
  }

  const handleExport = () => {
    // Get the filtered logs (what's actually visible) from EnhancedLogsData
    const filteredLogs = getFilteredLogsRef.current ? getFilteredLogsRef.current() : [];

    console.log('Export Debug:', {
      'filteredLogs.length': filteredLogs.length,
      'hasFilteredLogs': filteredLogs.length > 0
    });

    if (filteredLogs.length === 0) {
      console.warn('No logs to export!');
      return;
    }

    // Convert to CSV format
    // Each log object should be converted to a CSV row
    // Convert messageTime from UTC to IST format before exporting
    const csvRows = filteredLogs.map((log) => {
      // Create a copy of the log object and convert messageTime to IST
      const logForExport = { ...log };
      if (logForExport.messageTime) {
        logForExport.messageTime = fChargerLogDateTime(logForExport.messageTime);
      }

      const values = Object.values(logForExport).map((value) => `"${value || ''}"`);
      return values.join("; ");
    });

    // Add header row
    const headers = Object.keys(filteredLogs[0] || {}).map((key) => `"${key}"`).join("; ");
    const csv = [headers, ...csvRows].join("\n");

    downloadCSV(csv, "Logs");
  };

  return (
    <>
      <TabContext value={selectedTab}>
        <Box
          sx={{
            width: "100%",
            maxWidth: "100%",
            overflow: "hidden",
            mb: 2,
          }}
        >
          <RootTabStyle
            indicatorColor="transparent"
            centered
            length={tabsToShow.length}
            onChange={handleTabChange}
            sx={{
              width: "100%",
              maxWidth: "100%",
              overflow: "hidden",
            }}
          >
            {tabsToShow.map((tab) => (
              <RootTabItemStyles
                key={tab.value}
                value={tab.value}
                label={tab.label}
              />
            ))}
          </RootTabStyle>
        </Box>
        <Card
          sx={{
            p: 1.5,
            width: "100%",
            maxWidth: "100%",
            overflow: "visible",
          }}
        >
          <FormikProvider value={formik}>
            <Form
              autoComplete="off"
              id="charger"
              noValidate
              onSubmit={handleSubmit}
            >
              {/* Display validation errors */}
              {shouldShowFormErrors() && (
                <Box sx={{ mb: 2 }}>
                  <Alert severity="error" sx={{ mb: 2 }}>
                    <Typography
                      variant="subtitle2"
                      sx={{ fontWeight: 600, mb: 1 }}
                    >
                      Please fix the following errors:
                    </Typography>
                    <ul style={{ margin: 0, paddingLeft: "20px" }}>
                      {Object.entries(errors).map(([field, error]) => {
                        // If error is a string, render it directly
                        if (typeof error === "string") {
                          return (
                            <li key={field}>
                              <Typography variant="body2">{error}</Typography>
                            </li>
                          );
                        }
                        // If error is an array (likely for connectors)
                        if (Array.isArray(error)) {
                          return error.map((connectorError, index) => {
                            if (typeof connectorError === "object" && connectorError !== null) {
                              return Object.entries(connectorError).map(([subField, subError]) => (
                                <li key={`${field}-${index}-${subField}`}>
                                  <Typography variant="body2">
                                    Connector {index + 1}: {subError}
                                  </Typography>
                                </li>
                              ));
                            }
                            return null;
                          });
                        }
                        // If error is an object (for nested objects like address)
                        if (typeof error === "object" && error !== null) {
                          return Object.entries(error).map(([subField, subError]) => (
                            <li key={`${field}-${subField}`}>
                              <Typography variant="body2">{subError}</Typography>
                            </li>
                          ));
                        }
                        return null;
                      })}
                    </ul>
                  </Alert>
                </Box>
              )}

              <TabPanel value="general">
                {/* Main Content Grid - Single Column Layout */}
                <Grid container spacing={2}>
                  {/* Basic Information */}
                  <Grid item xs={12}>
                    <Card
                      sx={{ p: 2, display: "flex", flexDirection: "column" }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          mb: 2,
                        }}
                      >
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: 700,
                            color: "primary.main",
                            display: "flex",
                            alignItems: "center",
                            "&::before": {
                              content: '""',
                              width: 4,
                              height: 20,
                              backgroundColor: "primary.main",
                              borderRadius: 2,
                              mr: 1.5,
                            },
                          }}
                        >
                          Basic Information
                        </Typography>

                        {/* Charger QR Download Button - Only for existing chargers */}
                        {!isCreateCharger && (
                          <LoadingButton
                            size="medium"
                            type="button"
                            variant="contained"
                            startIcon={getIcon(downloadFill, 18, 18)}
                            onClick={() =>
                              handleShowCMQRCode(values["chargepoint_id"])
                            }
                            sx={{
                              background:
                                "linear-gradient(135deg, #2e7d32 0%, #4caf50 100%)",
                              boxShadow: "0 6px 20px rgba(46, 125, 50, 0.4)",
                              fontWeight: 700,
                              fontSize: "0.875rem",
                              px: 3,
                              py: 1.5,
                              borderRadius: 2,
                              textTransform: "none",
                              minHeight: "44px",
                              border: "2px solid transparent",
                              "&:hover": {
                                background:
                                  "linear-gradient(135deg, #1b5e20 0%, #2e7d32 100%)",
                                boxShadow: "0 8px 25px rgba(46, 125, 50, 0.5)",
                                transform: "translateY(-2px)",
                                border: "2px solid rgba(255, 255, 255, 0.2)",
                              },
                              "&:active": {
                                transform: "translateY(0px)",
                              },
                              transition:
                                "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                            }}
                          >
                            Charger QR
                          </LoadingButton>
                        )}
                      </Box>

                      {/* Top strip: read-only device identity + public/private
                          toggle, surfaced above the editable fields. */}
                      <Box
                        sx={{
                          mb: 2,
                          p: 1.5,
                          borderRadius: 2,
                          bgcolor: "grey.50",
                          border: "1px solid",
                          borderColor: "grey.200",
                          display: "flex",
                          flexWrap: "wrap",
                          alignItems: "center",
                          justifyContent:
                            dashboardV2Enabled && !isCreateCharger
                              ? "space-between"
                              : "flex-start",
                          gap: 2,
                        }}
                      >
                        {dashboardV2Enabled && !isCreateCharger && (
                          <Stack
                            direction="row"
                            spacing={3}
                            sx={{ flexWrap: "wrap", rowGap: 1 }}
                          >
                            {[
                              {
                                label: "Serial Number",
                                value:
                                  charger?.chargePointSerialNumber ||
                                  charger?.chargeBoxSerialNumber ||
                                  "—",
                              },
                              {
                                label: "Vendor",
                                value: charger?.chargePointVendor || "—",
                              },
                              {
                                label: "Software Version",
                                value: charger?.fwVersion || "—",
                              },
                            ].map((info) => (
                              <Box key={info.label} sx={{ minWidth: 0, maxWidth: 220 }}>
                                <Typography
                                  variant="caption"
                                  sx={{
                                    fontWeight: 600,
                                    color: "text.secondary",
                                    display: "block",
                                  }}
                                >
                                  {info.label}
                                </Typography>
                                <Tooltip title={info.value} placement="top" arrow>
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      fontWeight: 600,
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                      cursor: "default",
                                    }}
                                  >
                                    {info.value}
                                  </Typography>
                                </Tooltip>
                              </Box>
                            ))}
                          </Stack>
                        )}

                        <FormControlLabel
                          control={
                            <Switch
                              {...getFieldProps("showOnPortal")}
                              checked={!!values.showOnPortal}
                              disabled={isReadOnly}
                              onChange={(event) =>
                                setFieldValue("showOnPortal", event.target.checked)
                              }
                            />
                          }
                          label={
                            <Box>
                              <Typography
                                variant="subtitle2"
                                sx={{ fontWeight: 600, color: "text.primary" }}
                              >
                                {values.showOnPortal ? "Public" : "Private"}
                              </Typography>
                              <Typography
                                variant="caption"
                                sx={{ color: "text.secondary" }}
                              >
                                Visible on the public portal
                              </Typography>
                            </Box>
                          }
                          labelPlacement="end"
                          sx={{ alignItems: "center", m: 0, flexShrink: 0 }}
                        />
                      </Box>

                      <Grid container spacing={1.5} sx={{ flex: 1 }}>
                        {/* Row 1: Chargebox ID and Name */}
                        <Grid item xs={12} sm={6} md={3}>
                          <Stack
                            direction="row"
                            spacing={1}
                            alignItems="flex-start"
                          >
                            <FormControl fullWidth size="small">
                              <TextField
                                required
                                disabled={isReadOnly || !canEditChargerId}
                                label="Chargebox ID"
                                size="small"
                                {...getFieldProps("chargepoint_id")}
                                error={Boolean(
                                  shouldShowError("chargepoint_id")
                                )}
                                helperText={
                                  shouldShowError("chargepoint_id") ||
                                  (!isCreateCharger && isGrandParent
                                    ? "Super admin: saving a new ID renames the charger across all records. Re-provision the physical charger with the new ID afterwards; it can't be changed during an active session."
                                    : undefined)
                                }
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    borderRadius: 2,
                                    "&:hover .MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: "primary.main",
                                    },
                                  },
                                  "& .MuiInputLabel-root": {
                                    fontWeight: 600,
                                    color: "text.secondary",
                                  },
                                }}
                              />
                            </FormControl>
                            <Tooltip
                              title="Unique identifier for system management"
                              placement="right"
                              arrow
                            >
                              <IconButton
                                size="small"
                                sx={{
                                  mt: 1,
                                  color: "text.secondary",
                                  "&:hover": {
                                    color: "primary.main",
                                    backgroundColor: "primary.lighter",
                                  },
                                }}
                              >
                                <Icon
                                  icon={AlertCircleFill}
                                  width={16}
                                  height={16}
                                />
                              </IconButton>
                            </Tooltip>
                          </Stack>
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                          <FormControl
                            fullWidth
                            size="small"
                            error={Boolean(shouldShowError("chargepoint_name"))}
                          >
                            <TextField
                              required
                              disabled={isReadOnly}
                              label="Chargebox Name"
                              size="small"
                              {...getFieldProps("chargepoint_name")}
                              error={Boolean(
                                shouldShowError("chargepoint_name")
                              )}
                              helperText={shouldShowError("chargepoint_name")}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: 2,
                                  "&:hover .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "primary.main",
                                  },
                                },
                                "& .MuiInputLabel-root": {
                                  fontWeight: 600,
                                  color: "text.secondary",
                                },
                              }}
                            />
                          </FormControl>
                        </Grid>

                        {/* Row 2: Charger Type and Registration Status */}
                        <Grid item xs={12} sm={6} md={3}>
                          <FormControl
                            fullWidth
                            size="small"
                            error={Boolean(
                              touched.charger_type && errors.charger_type
                            )}
                          >
                            <InputLabel
                              id="chargerType"
                              sx={{ fontWeight: 600, color: "text.secondary" }}
                            >
                              Charger Type *
                            </InputLabel>
                            <Select
                              labelId="chargerType"
                              id={`chargerTypeId-${values.charger_type}`}
                              disabled={isReadOnly}
                              label="Charger Type"
                              {...getFieldProps("charger_type")}
                              sx={{
                                borderRadius: 2,
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "primary.main",
                                },
                              }}
                            >
                              <MenuItem value="AC">AC</MenuItem>
                              <MenuItem value="DC">DC</MenuItem>
                            </Select>
                            {touched.charger_type && (
                              <FormHelperText>
                                {errors.charger_type}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                          <FormControl
                            fullWidth
                            size="small"
                            error={Boolean(
                              touched.registrationStatus &&
                              errors.registrationStatus
                            )}
                          >
                            <InputLabel
                              id="registrationStatus"
                              sx={{ fontWeight: 600, color: "text.secondary" }}
                            >
                              Registration Status *
                            </InputLabel>
                            <Select
                              labelId="registrationStatus"
                              id="registrationStatus"
                              disabled={isReadOnly}
                              label="Registration Status"
                              {...getFieldProps("registrationStatus")}
                              sx={{
                                borderRadius: 2,
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "primary.main",
                                },
                              }}
                            >
                              <MenuItem selected value="">
                                <em>None</em>
                              </MenuItem>
                              <MenuItem value="Pending">Pending</MenuItem>
                              <MenuItem value="Accepted">Accepted</MenuItem>
                              <MenuItem value="Rejected">Rejected</MenuItem>
                            </Select>
                            {touched.registrationStatus && (
                              <FormHelperText>
                                {errors.registrationStatus}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                      </Grid>
                    </Card>
                  </Grid>
                </Grid>

                {/* {companyType.toUpperCase() === "P" &&
                  userType.toUpperCase() === "ROOT" && (
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={6} lg={6}>
                        <FormControl
                          fullWidth
                          size="small"
                          error={Boolean(touched.teamId && errors.teamId)}
                        >
                          <InputLabel
                            id="team-select-label"
                            sx={{ background: "#fff", px: 0.5 }}
                          >
                            Select Team
                          </InputLabel>
                          <Select
                            labelId="team-select-label"
                            id="team-select"
                            disabled={isReadOnly || !Array.isArray(teams?.data)}
                            {...getFieldProps("companyId")}
                          >
                            {Array.isArray(teams?.data) &&
                              teams.data.map((team) => (
                                <MenuItem
                                  key={team.companyId}
                                  value={team.companyId}
                                >
                                  {team.displayName}
                                </MenuItem>
                              ))}
                          </Select>
                          {touched.teamId && (
                            <FormHelperText>{errors.teamId}</FormHelperText>
                          )}
                        </FormControl>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="body2" color="textSecondary">
                          *Note: After selecting a team, please change the price
                          group accordingly. The correct price group can be
                          selected by logging into the selected team.*
                        </Typography>
                      </Grid>
                    </Grid>
                  )} */}

                {/* Charger Category Section */}
                {companyType.toUpperCase() === "GP" && (
                    <Box sx={{ mb: 3 }}>
                      <Card
                        sx={{
                          p: 3,
                          borderRadius: 2,
                          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                          border: "1px solid rgba(0,0,0,0.05)",
                        }}
                      >
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: 700,
                            color: "primary.main",
                            mb: 2,
                            display: "flex",
                            alignItems: "center",
                            "&::before": {
                              content: '""',
                              width: 4,
                              height: 24,
                              backgroundColor: "primary.main",
                              borderRadius: 2,
                              mr: 2,
                            },
                          }}
                        >
                          Charger Category
                        </Typography>

                        <FormControl
                          component="fieldset"
                          error={Boolean(
                            touched.charger_category && errors.charger_category
                          )}
                          sx={{ width: "100%" }}
                        >
                          <FormLabel
                            component="legend"
                            sx={{
                              mb: 2,
                              fontSize: "0.875rem",
                              fontWeight: 600,
                              color: "text.primary",
                            }}
                          >
                            Select Charger Category *
                          </FormLabel>
                          <RadioGroup
                            row
                            aria-label="charger-category"
                            name="charger_category"
                            value={values.charger_category || "paid"}
                            onChange={(e) =>
                              handleFieldChange(
                                "charger_category",
                                e.target.value
                              )
                            }
                            sx={{ gap: 3 }}
                          >
                            <FormControlLabel
                              value="paid"
                              control={
                                <Radio
                                  sx={{
                                    color: "primary.main",
                                    "&.Mui-checked": {
                                      color: "primary.main",
                                    },
                                  }}
                                />
                              }
                              label={
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                  }}
                                >
                                  <Typography
                                    variant="body2"
                                    sx={{ fontWeight: 500 }}
                                  >
                                    Paid Charging
                                  </Typography>
                                </Box>
                              }
                              disabled={isReadOnly}
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  fontSize: "0.875rem",
                                },
                              }}
                            />
                            <FormControlLabel
                              value="free"
                              control={
                                <Radio
                                  sx={{
                                    color: "success.main",
                                    "&.Mui-checked": {
                                      color: "success.main",
                                    },
                                  }}
                                />
                              }
                              label={
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                  }}
                                >
                                  <Typography
                                    variant="body2"
                                    sx={{ fontWeight: 500 }}
                                  >
                                    Free Charging
                                  </Typography>
                                </Box>
                              }
                              disabled={isReadOnly}
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  fontSize: "0.875rem",
                                },
                              }}
                            />
                          </RadioGroup>
                          {touched.charger_category && errors.charger_category && (
                            <FormHelperText error sx={{ mt: 1, ml: 0 }}>
                              {errors.charger_category}
                            </FormHelperText>
                          )}
                        </FormControl>
                      </Card>
                    </Box>
                  )}

                {/* Connectors Section */}
                <Box sx={{ mb: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      mb: 1.5,
                      flexWrap: "wrap",
                      gap: 2,
                    }}
                  >
                    <Typography
                      variant="subtitle1"
                      sx={{
                        fontWeight: 700,
                        color: "primary.main",
                        display: "flex",
                        alignItems: "center",
                        "&::before": {
                          content: '""',
                          width: 4,
                          height: 24,
                          backgroundColor: "primary.main",
                          borderRadius: 2,
                          mr: 2,
                        },
                      }}
                    >
                      Charging Connectors
                    </Typography>

                    {/* Connector Statistics */}
                    <Box
                      sx={{
                        display: "flex",
                        gap: 2,
                        alignItems: "center",
                        flexWrap: "wrap",
                      }}
                    >
                      <Chip
                        label={`${values.connectors.length} Connector${values.connectors.length !== 1 ? "s" : ""
                          }`}
                        color="primary"
                        variant="outlined"
                        size="small"
                        sx={{
                          fontWeight: 600,
                          fontSize: "0.75rem",
                        }}
                      />
                      {!isCreateCharger && (
                        <Chip
                          label={`${values.connectors.filter(
                            (c) => c.status === "Available"
                          ).length
                            } Available`}
                          color="success"
                          variant="outlined"
                          size="small"
                          sx={{
                            fontWeight: 600,
                            fontSize: "0.75rem",
                          }}
                        />
                      )}
                    </Box>
                  </Box>

                  <Grid container spacing={2}>
                    {values.connectors.map((value, index) => (
                      <Grid item xs={12} key={index}>
                        <Card
                          sx={{
                            p: 0,
                            borderRadius: 3,
                            boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                            border: "1px solid",
                            borderColor: "grey.200",
                            backgroundColor: "background.paper",
                            overflow: "hidden",
                            position: "relative",
                            "&:hover": {
                              boxShadow: "0 8px 30px rgba(0,0,0,0.15)",
                              borderColor: "primary.light",
                              // Transform removed
                            },
                            // Transitions removed
                          }}
                        >
                          {/* Connector Header */}
                          <Box
                            sx={{
                              background:
                                "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)",
                              p: 2,
                              color: "white",
                              position: "relative",
                              overflow: "hidden",
                              "&::before": {
                                content: '""',
                                position: "absolute",
                                top: 0,
                                right: 0,
                                width: "100px",
                                height: "100%",
                                background:
                                  "linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.1) 50%, transparent 70%)",
                                transform: "translateX(100px)",
                                transition: "transform 0.6s ease",
                              },
                              "&:hover::before": {
                                transform: "translateX(-100px)",
                              },
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                position: "relative",
                                zIndex: 1,
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 2,
                                }}
                              >
                                <Box
                                  sx={{
                                    width: 40,
                                    height: 40,
                                    borderRadius: "50%",
                                    background: "rgba(255,255,255,0.2)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backdropFilter: "blur(10px)",
                                  }}
                                >
                                  <Icon
                                    icon="eva:flash-outline"
                                    width={20}
                                    height={20}
                                    style={{ color: "white" }}
                                  />
                                </Box>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "middle",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Typography
                                    variant="subtitle1"
                                    sx={{
                                      fontWeight: 700,
                                      fontSize: "1.1rem",
                                      color: "white",
                                      mb: 0.5,
                                    }}
                                  >
                                    Connector {index + 1}
                                  </Typography>
                                  {/* <Typography
                                    variant="caption"
                                    sx={{
                                      color: 'rgba(255,255,255,0.8)',
                                      fontSize: '0.75rem',
                                      textTransform: 'uppercase',
                                      letterSpacing: '0.5px',
                                    }}
                                  >
                                    {value.connectorType || 'No Type Selected'}
                                  </Typography> */}
                                </Box>
                              </Box>

                              {/* Right-aligned buttons container */}
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1.5,
                                }}
                              >
                                {/* Single download dropdown: Paytm UPI board
                                    (with / without price) + Razorpay UPI QR */}
                                {!isCreateCharger && (
                                  <ConnectorUpi
                                    variant="download"
                                    teamId={teamId}
                                    chargerId={charger?.chargepoint_id}
                                    connectorName={value.connectorName}
                                    chargerName={
                                      values.chargepoint_name ||
                                      charger?.chargepoint_name
                                    }
                                    connectorNumber={
                                      value.connectorId ||
                                      value.connector_id ||
                                      index + 1
                                    }
                                    totalConnectors={values.connectors.length}
                                    tariff={
                                      value.priceperKW ||
                                      value.priceper_kw ||
                                      value.price_per_kw ||
                                      value.rate ||
                                      charger?.rate ||
                                      values.rate ||
                                      ""
                                    }
                                    priceGroupId={value.priceGroupId}
                                    boardEnabled={
                                      Boolean(domainConfig?.isAmik) ||
                                      ["localhost", "127.0.0.1"].includes(
                                        window.location.hostname
                                      )
                                    }
                                    razorpayQrCodeUrl={value.qrCodeUrl}
                                    razorpayGenerating={
                                      isGenQR &&
                                      genQrConnectorPk === value.connector_pk
                                    }
                                    onRazorpayDownload={() =>
                                      handleShowRazorPayQRCode(value.qrCodeUrl)
                                    }
                                    onRazorpayGenerate={() => {
                                      setGenQrConnectorPk(value.connector_pk);
                                      generateQRCode(value.connector_pk);
                                    }}
                                  />
                                )}

                                {/* Status Indicator - Second */}
                                {!isCreateCharger &&
                                  value.hasOwnProperty("status") && (
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                        px: 2,
                                        py: 1,
                                        borderRadius: 2,
                                        background: "rgba(255,255,255,0.15)",
                                        backdropFilter: "blur(10px)",
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          width: 8,
                                          height: 8,
                                          borderRadius: "50%",
                                          backgroundColor:
                                            value?.status === "Unavailable" ||
                                              value?.status === "Offline" ||
                                              value?.status === "Faulted"
                                              ? "#ffcdd2"
                                              : value?.status === "Available" ||
                                                value?.status === "Preparing"
                                                ? "#c8e6c9"
                                                : "#ffe0b2",
                                          boxShadow: `0 0 8px ${value?.status === "Unavailable" ||
                                              value?.status === "Offline" ||
                                              value?.status === "Faulted"
                                              ? "rgba(244, 67, 54, 0.5)"
                                              : value?.status === "Available" ||
                                                value?.status === "Preparing"
                                                ? "rgba(76, 175, 80, 0.5)"
                                                : "rgba(255, 152, 0, 0.5)"
                                            }`,
                                        }}
                                      />
                                      <Typography
                                        variant="caption"
                                        sx={{
                                          fontWeight: 600,
                                          fontSize: "0.75rem",
                                          color: "white",
                                          textTransform: "uppercase",
                                          letterSpacing: "0.5px",
                                        }}
                                      >
                                        {value?.status || "--"}
                                      </Typography>
                                    </Box>
                                  )}
                              </Box>
                            </Box>
                          </Box>

                          {/* Connector Content */}
                          <Box sx={{ p: 3 }}>
                            {/* Enhanced Form Fields - Full Width Layout */}
                            <Grid
                              container
                              spacing={1.5}
                              alignItems="flex-start"
                            >
                              <Grid item xs={12} sm={6} md={3}>
                                <Box sx={{ mb: 0.5 }}>
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      fontWeight: 600,
                                      color: "text.secondary",
                                      textTransform: "uppercase",
                                      letterSpacing: "0.5px",
                                      fontSize: "0.7rem",
                                    }}
                                  >
                                    Connector Name
                                  </Typography>
                                </Box>
                                <FormControl fullWidth size="small">
                                  <Field
                                    name={`connectors[${index}].connectorName`}
                                  >
                                    {({
                                      field,
                                      meta,
                                    }) => (
                                      <>
                                        <TextField
                                          disabled={isReadOnly}
                                          placeholder="Enter connector name"
                                          size="small"
                                          {...field}
                                          onChange={(e) => {
                                            field.onChange(e);
                                            const val = e.target.value;
                                            if (val.trim().length <= 6) {
                                              // Short names are always valid — clear any error
                                              // and cancel a pending DB check.
                                              if (midValidateTimers.current[index]) {
                                                clearTimeout(midValidateTimers.current[index]);
                                                delete midValidateTimers.current[index];
                                              }
                                              setConnectorLengthErrors((prev) => {
                                                const next = { ...prev };
                                                delete next[index];
                                                return next;
                                              });
                                            } else {
                                              // Longer than 6 chars: don't flag it yet. Debounce a
                                              // DB check so the error only shows if it is NOT a MID.
                                              if (midValidateTimers.current[index]) {
                                                clearTimeout(midValidateTimers.current[index]);
                                              }
                                              midValidateTimers.current[index] = setTimeout(() => {
                                                validateConnectorName(index, val);
                                              }, 500);
                                            }
                                          }}
                                        onBlur={(e) => {
                                            field.onBlur(e);
                                            // Validate immediately on blur (cancel pending debounce).
                                            if (midValidateTimers.current[index]) {
                                              clearTimeout(midValidateTimers.current[index]);
                                              delete midValidateTimers.current[index];
                                            }
                                            validateConnectorName(index, e.target.value);
                                          }}
                                          error={Boolean(meta.touched && meta.error) || Boolean(connectorLengthErrors[index])}
                                          sx={{
                                            "& .MuiOutlinedInput-root": {
                                              borderRadius: 2,
                                              backgroundColor:
                                                "rgba(25, 118, 210, 0.02)",
                                              "&:hover .MuiOutlinedInput-notchedOutline":
                                              {
                                                borderColor: "primary.main",
                                                borderWidth: 2,
                                              },
                                              "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                              {
                                                borderColor: "primary.main",
                                                borderWidth: 2,
                                              },
                                            },
                                            "& .MuiInputLabel-root": {
                                              fontWeight: 500,
                                              color: "text.secondary",
                                            },
                                          }}
                                        />
                                        {connectorLengthErrors[index] && (
                                          <Typography
                                            variant="caption"
                                            sx={{ color: "error.main", mt: 0.5, display: "block" }}
                                          >
                                            Connector length cannot be more than 6 characters
                                          </Typography>
                                        )}
                                      </>
                                    )}
                                  </Field>
                                </FormControl>
                                {/* Paytm UPI URL shown below the connector name
                                    (edit mode, name > 3 chars). */}
                                {!isCreateCharger && (
                                  <ConnectorUpi
                                    variant="url"
                                    teamId={teamId}
                                    chargerId={charger?.chargepoint_id}
                                    connectorName={value.connectorName}
                                  />
                                )}
                              </Grid>
                              <Grid item xs={12} sm={6} md={3}>
                                <Box sx={{ mb: 0.5 }}>
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      fontWeight: 600,
                                      color: "text.secondary",
                                      textTransform: "uppercase",
                                      letterSpacing: "0.5px",
                                      fontSize: "0.7rem",
                                    }}
                                  >
                                    Price Group
                                  </Typography>
                                </Box>
                                <FormControl
                                  fullWidth
                                  size="small"
                                  error={Boolean(
                                    touched.connectors?.[index]?.priceGroupId &&
                                    errors.connectors?.[index]?.priceGroupId
                                  )}
                                >
                                  <Field
                                    name={`connectors[${index}].priceGroupId`}
                                  >
                                    {({
                                      field,
                                      form: { touched, errors },
                                      meta,
                                    }) => (
                                      <>
                                        <Select
                                          disabled={isReadOnly}
                                          {...field}
                                          value={field.value || ""}
                                          displayEmpty
                                          error={Boolean(meta.touched && meta.error)}
                                          sx={{
                                            borderRadius: 2,
                                            backgroundColor:
                                              "rgba(25, 118, 210, 0.02)",
                                            "&:hover .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderColor: "primary.main",
                                              borderWidth: 2,
                                            },
                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderColor: "primary.main",
                                              borderWidth: 2,
                                            },
                                          }}
                                        >
                                          <MenuItem value="">
                                            <em style={{ color: "#999" }}>
                                              Select Price Group
                                            </em>
                                          </MenuItem>
                                          {priceGroups &&
                                            priceGroups.map((group) => (
                                              <MenuItem
                                                key={group.priceGroupId}
                                                value={group.priceGroupId}
                                              >
                                                {group.name}
                                              </MenuItem>
                                            ))}
                                        </Select>
                                        {meta.touched && meta.error && (
                                          <FormHelperText error>
                                            {meta.error}
                                          </FormHelperText>
                                        )}
                                        {field.value && (
                                          <PriceGroupPriceDisplay
                                            priceGroupId={field.value}
                                          />
                                        )}
                                      </>
                                    )}
                                  </Field>
                                </FormControl>
                              </Grid>
                              <Grid item xs={12} sm={6} md={3}>
                                <Box sx={{ mb: 0.5 }}>
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      fontWeight: 600,
                                      color: "text.secondary",
                                      textTransform: "uppercase",
                                      letterSpacing: "0.5px",
                                      fontSize: "0.7rem",
                                    }}
                                  >
                                    Connector Type
                                  </Typography>
                                </Box>
                                <FormControl
                                  fullWidth
                                  size="small"
                                  error={Boolean(
                                    touched.connectors?.[index]?.connectorType &&
                                    errors.connectors?.[index]?.connectorType
                                  )}
                                >
                                  <Field
                                    name={`connectors[${index}].connectorType`}
                                  >
                                    {({
                                      field,
                                      form: { touched, errors },
                                      meta,
                                    }) => (
                                      <>
                                        <Select
                                          disabled={isReadOnly}
                                          {...field}
                                          value={field.value || ""}
                                          displayEmpty
                                          error={Boolean(meta.touched && meta.error)}
                                          sx={{
                                            borderRadius: 2,
                                            backgroundColor:
                                              "rgba(25, 118, 210, 0.02)",
                                            "&:hover .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderColor: "primary.main",
                                              borderWidth: 2,
                                            },
                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderColor: "primary.main",
                                              borderWidth: 2,
                                            },
                                          }}
                                        >
                                          <MenuItem value="">
                                            <em style={{ color: "#999" }}>
                                              Select Connector Type
                                            </em>
                                          </MenuItem>
                                          {ConnectorType.map((connector) => (
                                            <MenuItem
                                              key={connector.id}
                                              value={connector.value}
                                            >
                                              {connector.type}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                        {meta.touched && meta.error && (
                                          <FormHelperText error>
                                            {meta.error}
                                          </FormHelperText>
                                        )}
                                      </>
                                    )}
                                  </Field>
                                </FormControl>
                              </Grid>
                              <Grid item xs={6} sm={3} md={1.5}>
                                <Box sx={{ mb: 0.5 }}>
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      fontWeight: 600,
                                      color: "text.secondary",
                                      textTransform: "uppercase",
                                      letterSpacing: "0.5px",
                                      fontSize: "0.7rem",
                                    }}
                                  >
                                    Power (kW)
                                  </Typography>
                                </Box>
                                <FormControl fullWidth size="small">
                                  <Field name={`connectors[${index}].kw`}>
                                    {({
                                      field,
                                      form: { touched, errors },
                                      meta,
                                    }) => (
                                      <TextField
                                        disabled={isReadOnly}
                                        placeholder="0.0"
                                        size="small"
                                        type="number"
                                        inputProps={{ step: "any", min: 0 }}
                                        {...field}
                                        error={Boolean(meta.touched && meta.error)}
                                        helperText={meta.touched && meta.error}
                                        InputProps={{
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <Typography
                                                variant="caption"
                                                sx={{
                                                  fontWeight: 600,
                                                  color: "primary.main",
                                                  fontSize: "0.75rem",
                                                }}
                                              >
                                                kW
                                              </Typography>
                                            </InputAdornment>
                                          ),
                                        }}
                                        sx={{
                                          "& .MuiOutlinedInput-root": {
                                            borderRadius: 2,
                                            backgroundColor:
                                              "rgba(25, 118, 210, 0.02)",
                                            "&:hover .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderColor: "primary.main",
                                              borderWidth: 2,
                                            },
                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderColor: "primary.main",
                                              borderWidth: 2,
                                            },
                                          },
                                          "& .MuiInputLabel-root": {
                                            fontWeight: 500,
                                            color: "text.secondary",
                                          },
                                        }}
                                      />
                                    )}
                                  </Field>
                                </FormControl>
                              </Grid>
                              <Grid item xs={6} sm={3} md={1.5}>
                                <Box sx={{ mb: 0.5 }}>
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      fontWeight: 600,
                                      color: "text.secondary",
                                      textTransform: "uppercase",
                                      letterSpacing: "0.5px",
                                      fontSize: "0.7rem",
                                    }}
                                  >
                                    Voltage (V)
                                  </Typography>
                                </Box>
                                <FormControl fullWidth size="small">
                                  <Field name={`connectors[${index}].volt`}>
                                    {({
                                      field,
                                      form: { touched, errors },
                                      meta,
                                    }) => (
                                      <TextField
                                        disabled={isReadOnly}
                                        placeholder="0"
                                        size="small"
                                        type="number"
                                        inputProps={{ step: "any", min: 0 }}
                                        {...field}
                                        error={Boolean(meta.touched && meta.error)}
                                        helperText={meta.touched && meta.error}
                                        InputProps={{
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <Typography
                                                variant="caption"
                                                sx={{
                                                  fontWeight: 600,
                                                  color: "primary.main",
                                                  fontSize: "0.75rem",
                                                }}
                                              >
                                                V
                                              </Typography>
                                            </InputAdornment>
                                          ),
                                        }}
                                        sx={{
                                          "& .MuiOutlinedInput-root": {
                                            borderRadius: 2,
                                            backgroundColor:
                                              "rgba(25, 118, 210, 0.02)",
                                            "&:hover .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderColor: "primary.main",
                                              borderWidth: 2,
                                            },
                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderColor: "primary.main",
                                              borderWidth: 2,
                                            },
                                          },
                                          "& .MuiInputLabel-root": {
                                            fontWeight: 500,
                                            color: "text.secondary",
                                          },
                                        }}
                                      />
                                    )}
                                  </Field>
                                </FormControl>
                              </Grid>
                              {/* Action Buttons */}
                              <Grid item xs={12} sm={6} md={3}>
                                <Box
                                  sx={{
                                    display: "flex",
                                    gap: 1,
                                    justifyContent: "center",
                                    alignItems: "flex-end",
                                    height: "100%",
                                  }}
                                >
                                  {values.connectors.length > 1 &&
                                    isCreateCharger && (
                                      <Tooltip
                                        title="Remove Connector"
                                        placement="top"
                                        arrow
                                      >
                                        <LoadingButton
                                          size="small"
                                          type="button"
                                          variant="contained"
                                          onClick={() =>
                                            handleAddAndDeleteConnectors(index)
                                          }
                                          sx={{
                                            backgroundColor: "error.main",
                                            color: "white",
                                            minWidth: "auto",
                                            px: 2,
                                            py: 1,
                                            borderRadius: 2,
                                            "&:hover": {
                                              backgroundColor: "error.dark",
                                              // Transform removed
                                              boxShadow:
                                                "0 4px 12px rgba(244, 67, 54, 0.3)",
                                            },
                                            // Transitions removed
                                          }}
                                        >
                                          <Icon
                                            icon={TrashOutline}
                                            width={18}
                                            height={18}
                                          />
                                        </LoadingButton>
                                      </Tooltip>
                                    )}
                                </Box>
                              </Grid>
                            </Grid>
                          </Box>
                        </Card>
                      </Grid>
                    ))}
                    {/* Add Connector Button */}
                    {values.connectors.length !== 4 && isCreateCharger && (
                      <Grid item xs={12}>
                        <Card
                          sx={{
                            p: 1.5,
                            borderRadius: 3,
                            boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                            border: "2px dashed rgba(76, 175, 80, 0.3)",
                            background:
                              "linear-gradient(135deg, rgba(76, 175, 80, 0.02) 0%, rgba(102, 187, 106, 0.02) 100%)",
                            cursor: "pointer",
                            "&:hover": {
                              borderColor: "rgba(76, 175, 80, 0.5)",
                              background:
                                "linear-gradient(135deg, rgba(76, 175, 80, 0.05) 0%, rgba(102, 187, 106, 0.05) 100%)",
                              boxShadow: "0 8px 25px rgba(76, 175, 80, 0.15)",
                            },
                          }}
                        >
                          <Box
                            onClick={() => handleAddAndDeleteConnectors()}
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              textAlign: "center",
                              cursor: "pointer",
                              py: 1.5,
                            }}
                          >
                            <Box
                              sx={{
                                width: 48,
                                height: 48,
                                borderRadius: "50%",
                                background:
                                  "linear-gradient(135deg, #4caf50 0%, #66bb6a 100%)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                mb: 1.5,
                                boxShadow: "0 4px 12px rgba(76, 175, 80, 0.3)",
                              }}
                            >
                              <Icon
                                icon={PlusFill}
                                width={24}
                                height={24}
                                style={{ color: "white" }}
                              />
                            </Box>
                            <Typography
                              variant="subtitle1"
                              sx={{
                                fontWeight: 700,
                                color: "#4caf50",
                                mb: 0.5,
                                fontSize: "0.9rem",
                              }}
                            >
                              Add Another Connector
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{
                                color: "text.secondary",
                                opacity: 0.8,
                                fontSize: "0.75rem",
                              }}
                            >
                              Click to add more charging connectors to this
                              station
                            </Typography>
                          </Box>
                        </Card>
                      </Grid>
                    )}
                  </Grid>
                </Box>
                {/* Additional Information Section */}
                <Box sx={{ mb: 2 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontWeight: 700,
                      color: "primary.main",
                      mb: 1.5,
                      display: "flex",
                      alignItems: "center",
                      "&::before": {
                        content: '""',
                        width: 4,
                        height: 24,
                        backgroundColor: "primary.main",
                        borderRadius: 2,
                        mr: 2,
                      },
                    }}
                  >
                    Additional Information
                  </Typography>

                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth size="small">
                        <TextField
                          label="Description"
                          size="small"
                          disabled={isReadOnly}
                          {...getFieldProps("description")}
                          error={Boolean(touched.name && errors.name)}
                          multiline
                          rows={3}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: 2,
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "primary.main",
                              },
                            },
                            "& .MuiInputLabel-root": {
                              fontWeight: 600,
                              color: "text.secondary",
                            },
                          }}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth size="small">
                        <TextField
                          label="Admin Address"
                          size="small"
                          disabled={isReadOnly}
                          {...getFieldProps("adminAddress")}
                          error={Boolean(touched.name && errors.name)}
                          multiline
                          rows={3}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: 2,
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "primary.main",
                              },
                            },
                            "& .MuiInputLabel-root": {
                              fontWeight: 600,
                              color: "text.secondary",
                            },
                          }}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <FormControl fullWidth size="small">
                        <TextField
                          label="Additional Notes"
                          size="small"
                          disabled={isReadOnly}
                          {...getFieldProps("note")}
                          error={Boolean(touched.name && errors.name)}
                          multiline
                          rows={3}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: 2,
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "primary.main",
                              },
                            },
                            "& .MuiInputLabel-root": {
                              fontWeight: 600,
                              color: "text.secondary",
                            },
                          }}
                        />
                      </FormControl>
                    </Grid>
                    {/* Public/Private toggle moved to the top of Basic Information. */}
                  </Grid>
                </Box>
              </TabPanel>

              <TabPanel value="address">
                <Box sx={{ width: "100%", maxWidth: "100%" }}>
                  {/* Header Section */}
                  <Box
                    sx={{
                      mb: 2,
                      p: 2,
                      borderRadius: 3,
                      background:
                        "linear-gradient(135deg, #f8f9ff 0%, #e3f2fd 100%)",
                      border: "1px solid rgba(25, 118, 210, 0.1)",
                      boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                      <Box
                        sx={{
                          width: 48,
                          height: 48,
                          borderRadius: "50%",
                          background:
                            "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mr: 2,
                          boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)",
                        }}
                      >
                        <Icon
                          icon="eva:map-outline"
                          width={24}
                          height={24}
                          color="white"
                        />
                      </Box>
                      <Box>
                        <Typography
                          variant="h5"
                          sx={{
                            fontWeight: 700,
                            color: "primary.main",
                            mb: 0.5,
                          }}
                        >
                          Location & Address
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            color: "text.secondary",
                            fontWeight: 500,
                          }}
                        >
                          Configure charger location, amenities, and contact
                          information
                        </Typography>
                      </Box>
                      <Box sx={{ ml: "auto", pl: 2, flexShrink: 0 }}>
                        <ShareLocationButton
                          name={values.chargepoint_name || values.chargepoint_id}
                          address={[values.street, values.city, values.state, values.zipcode, values.country]
                            .map((part) => (part == null ? "" : String(part).trim()))
                            .filter(Boolean)
                            .join(", ")}
                          lat={values.locationLatitude}
                          lng={values.locationLongitude}
                        />
                      </Box>
                    </Box>
                  </Box>

                  {/* Main Content */}
                  <Grid container spacing={2}>
                    {/* Map Section */}
                    <Grid item xs={12} lg={6}>
                      <Card
                        sx={{
                          p: 2,
                          borderRadius: 3,
                          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                          border: "1px solid rgba(0,0,0,0.05)",
                          background:
                            "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                          height: "fit-content",
                        }}
                      >
                        <Box sx={{ mb: 1.5 }}>
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 600,
                              color: "text.primary",
                              mb: 1,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Icon
                              icon="eva:map-outline"
                              width={20}
                              height={20}
                              style={{ marginRight: "8px" }}
                            />
                            Location Map
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: "text.secondary",
                              fontSize: "0.875rem",
                            }}
                          >
                            Select the exact location of your charging station
                          </Typography>
                        </Box>

                        <Map
                          onPlaces={handlePlacesChanged}
                          lat={values.locationLatitude}
                          lng={values.locationLongitude}
                          address={values.street}
                          showMessage={true}
                        />
                      </Card>
                    </Grid>

                    {/* Location Details Section */}
                    <Grid item xs={12} lg={6}>
                      <Card
                        sx={{
                          p: 2,
                          borderRadius: 3,
                          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                          border: "1px solid rgba(0,0,0,0.05)",
                          background:
                            "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                          height: "fit-content",
                        }}
                      >
                        <Box sx={{ mb: 1.5 }}>
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 600,
                              color: "text.primary",
                              mb: 1,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Icon
                              icon="eva:navigation-outline"
                              width={20}
                              height={20}
                              style={{ marginRight: "8px" }}
                            />
                            Coordinates
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: "text.secondary",
                              fontSize: "0.875rem",
                            }}
                          >
                            Precise location coordinates for the charging
                            station
                          </Typography>
                        </Box>

                        <Grid container spacing={2}>
                          {/* Latitude */}
                          <Grid item xs={12} sm={6}>
                            <TextField
                              fullWidth
                              label="Latitude"
                              size="medium"
                              type="text"
                              {...getFieldProps("locationLatitude")}
                              onChange={(e) => {
                                let val = e.target.value;
                                // Allow only digits, one decimal point, and one leading minus sign
                                if (val !== "" && !/^-?\d*\.?\d*$/.test(val)) return;
                                setFieldValue("locationLatitude", val);
                              }}
                              error={Boolean(touched.locationLatitude && errors.locationLatitude)}
                              helperText={touched.locationLatitude && errors.locationLatitude}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  backgroundColor: "rgba(25, 118, 210, 0.02)",
                                  "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#1976d2", borderWidth: 2 },
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#1976d2", borderWidth: 2 },
                                },
                                "& .MuiInputLabel-root": { fontWeight: 500 },
                              }}
                            />
                          </Grid>
                          {/* Longitude */}
                          <Grid item xs={12} sm={6}>
                            <TextField
                              fullWidth
                              label="Longitude"
                              size="medium"
                              type="text"
                              {...getFieldProps("locationLongitude")}
                              onChange={(e) => {
                                let val = e.target.value;
                                // Allow only digits, one decimal point, and one leading minus sign
                                if (val !== "" && !/^-?\d*\.?\d*$/.test(val)) return;
                                setFieldValue("locationLongitude", val);
                              }}
                              error={Boolean(touched.locationLongitude && errors.locationLongitude)}
                              helperText={touched.locationLongitude && errors.locationLongitude}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  backgroundColor: "rgba(25, 118, 210, 0.02)",
                                  "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#1976d2", borderWidth: 2 },
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#1976d2", borderWidth: 2 },
                                },
                                "& .MuiInputLabel-root": { fontWeight: 500 },
                              }}
                            />
                          </Grid>
                          {/* City */}
                          <Grid item xs={12} sm={6}>
                            <TextField
                              fullWidth
                              required
                              label="City"
                              disabled={isReadOnly}
                              {...getFieldProps("city")}
                              InputLabelProps={{ shrink: values.city || isGeocodingAddress ? true : undefined }}
                              error={Boolean(touched.city && errors.city)}
                              helperText={touched.city && errors.city}
                              InputProps={{
                                ...(isGeocodingAddress && {
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <Box sx={{ width: 18, height: 18, borderRadius: '50%', border: '2px solid #1976d2', borderTopColor: 'transparent', animation: 'spin 0.8s linear infinite', '@keyframes spin': { '0%': { transform: 'rotate(0deg)' }, '100%': { transform: 'rotate(360deg)' } } }} />
                                    </InputAdornment>
                                  ),
                                }),
                              }}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  backgroundColor: isGeocodingAddress ? "rgba(25, 118, 210, 0.06)" : "rgba(25, 118, 210, 0.02)",
                                  animation: isGeocodingAddress ? "pulse 1.5s ease-in-out infinite" : "none",
                                  "@keyframes pulse": { "0%, 100%": { opacity: 1 }, "50%": { opacity: 0.7 } },
                                  "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#1976d2", borderWidth: 2 },
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#1976d2", borderWidth: 2 },
                                },
                                "& .MuiInputLabel-root": { fontWeight: 500 },
                              }}
                            />
                          </Grid>
                          {/* State */}
                          <Grid item xs={12} sm={6}>
                            <TextField
                              fullWidth
                              required
                              label="State"
                              disabled={isReadOnly}
                              {...getFieldProps("state")}
                              InputLabelProps={{ shrink: values.state || isGeocodingAddress ? true : undefined }}
                              error={Boolean(touched.state && errors.state)}
                              helperText={touched.state && errors.state}
                              InputProps={{
                                ...(isGeocodingAddress && {
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <Box sx={{ width: 18, height: 18, borderRadius: '50%', border: '2px solid #1976d2', borderTopColor: 'transparent', animation: 'spin 0.8s linear infinite', '@keyframes spin': { '0%': { transform: 'rotate(0deg)' }, '100%': { transform: 'rotate(360deg)' } } }} />
                                    </InputAdornment>
                                  ),
                                }),
                              }}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  backgroundColor: isGeocodingAddress ? "rgba(25, 118, 210, 0.06)" : "rgba(25, 118, 210, 0.02)",
                                  animation: isGeocodingAddress ? "pulse 1.5s ease-in-out infinite" : "none",
                                  "@keyframes pulse": { "0%, 100%": { opacity: 1 }, "50%": { opacity: 0.7 } },
                                  "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#1976d2", borderWidth: 2 },
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#1976d2", borderWidth: 2 },
                                },
                                "& .MuiInputLabel-root": { fontWeight: 500 },
                              }}
                            />
                          </Grid>
                          {/* Zip Code */}
                          <Grid item xs={12} sm={6}>
                            <TextField
                              fullWidth
                              required
                              label="Zip Code"
                              disabled={isReadOnly}
                              {...getFieldProps("zipcode")}
                              InputLabelProps={{ shrink: values.zipcode || isGeocodingAddress ? true : undefined }}
                              error={Boolean(touched.zipcode && errors.zipcode)}
                              helperText={touched.zipcode && errors.zipcode}
                              InputProps={{
                                ...(isGeocodingAddress && {
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <Box sx={{ width: 18, height: 18, borderRadius: '50%', border: '2px solid #1976d2', borderTopColor: 'transparent', animation: 'spin 0.8s linear infinite', '@keyframes spin': { '0%': { transform: 'rotate(0deg)' }, '100%': { transform: 'rotate(360deg)' } } }} />
                                    </InputAdornment>
                                  ),
                                }),
                              }}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  backgroundColor: isGeocodingAddress ? "rgba(25, 118, 210, 0.06)" : "rgba(25, 118, 210, 0.02)",
                                  animation: isGeocodingAddress ? "pulse 1.5s ease-in-out infinite" : "none",
                                  "@keyframes pulse": { "0%, 100%": { opacity: 1 }, "50%": { opacity: 0.7 } },
                                  "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#1976d2", borderWidth: 2 },
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#1976d2", borderWidth: 2 },
                                },
                                "& .MuiInputLabel-root": { fontWeight: 500 },
                              }}
                            />
                          </Grid>
                          {/* Country */}
                          <Grid item xs={12} sm={6}>
                            <TextField
                              fullWidth
                              required
                              label="Country"
                              disabled={isReadOnly}
                              {...getFieldProps("country")}
                              InputLabelProps={{ shrink: values.country || isGeocodingAddress ? true : undefined }}
                              error={Boolean(touched.country && errors.country)}
                              helperText={touched.country && errors.country}
                              InputProps={{
                                ...(isGeocodingAddress && {
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <Box sx={{ width: 18, height: 18, borderRadius: '50%', border: '2px solid #1976d2', borderTopColor: 'transparent', animation: 'spin 0.8s linear infinite', '@keyframes spin': { '0%': { transform: 'rotate(0deg)' }, '100%': { transform: 'rotate(360deg)' } } }} />
                                    </InputAdornment>
                                  ),
                                }),
                              }}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  backgroundColor: isGeocodingAddress ? "rgba(25, 118, 210, 0.06)" : "rgba(25, 118, 210, 0.02)",
                                  animation: isGeocodingAddress ? "pulse 1.5s ease-in-out infinite" : "none",
                                  "@keyframes pulse": { "0%, 100%": { opacity: 1 }, "50%": { opacity: 0.7 } },
                                  "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#1976d2", borderWidth: 2 },
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#1976d2", borderWidth: 2 },
                                },
                                "& .MuiInputLabel-root": { fontWeight: 500 },
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>

                    {/* Amenities Section */}
                    <Grid item xs={12} md={6}>
                      <Card
                        sx={{
                          p: 2,
                          borderRadius: 3,
                          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                          border: "1px solid rgba(0,0,0,0.05)",
                          background:
                            "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                          height: "fit-content",
                        }}
                      >
                        <Box sx={{ mb: 1.5 }}>
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 600,
                              color: "text.primary",
                              mb: 1,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Icon
                              icon="eva:star-outline"
                              width={20}
                              height={20}
                              style={{ marginRight: "8px" }}
                            />
                            Nearby Amenities
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: "text.secondary",
                              fontSize: "0.875rem",
                            }}
                          >
                            Select amenities available near the charging station
                          </Typography>
                        </Box>

                        <FormControl fullWidth>
                          <InputLabel
                            id="amenities-label"
                            sx={{ fontWeight: 500 }}
                          >
                            Select Amenities
                          </InputLabel>
                          <Select
                            labelId="amenities-label"
                            id="amenities-select"
                            multiple
                            {...getFieldProps("amenities")}
                            input={
                              <OutlinedInput
                                id="select-multiple-chip"
                                label="Select Amenities"
                              />
                            }
                            renderValue={(selected) => (
                              <Box
                                sx={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: 0.5,
                                }}
                              >
                                {selected.map((value) => (
                                  <Chip
                                    key={value}
                                    label={value}
                                    size="small"
                                    sx={{
                                      backgroundColor:
                                        "rgba(25, 118, 210, 0.1)",
                                      color: "primary.main",
                                      fontWeight: 500,
                                      "& .MuiChip-deleteIcon": {
                                        color: "primary.main",
                                      },
                                    }}
                                  />
                                ))}
                              </Box>
                            )}
                            MenuProps={{
                              PaperProps: {
                                style: {
                                  maxHeight: 48 * 4.5 + 8,
                                  width: 250,
                                },
                              },
                            }}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                backgroundColor: "rgba(25, 118, 210, 0.02)",
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "#1976d2",
                                  borderWidth: 2,
                                },
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  borderColor: "#1976d2",
                                  borderWidth: 2,
                                },
                              },
                              "& .MuiInputLabel-root": {
                                fontWeight: 500,
                              },
                            }}
                          >
                            {AMENITIES.map((am) => (
                              <MenuItem
                                key={am.value}
                                value={am.value}
                                sx={{
                                  "&:hover": {
                                    backgroundColor: "rgba(25, 118, 210, 0.04)",
                                  },
                                  "&.Mui-selected": {
                                    backgroundColor: "rgba(25, 118, 210, 0.08)",
                                  },
                                }}
                              >
                                {am.text}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Card>
                    </Grid>

                    {/* Tags Section */}
                    <Grid item xs={12} md={6}>
                      <Card
                        sx={{
                          p: 2,
                          borderRadius: 3,
                          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                          border: "1px solid rgba(0,0,0,0.05)",
                          background:
                            "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                          height: "fit-content",
                        }}
                      >
                        <Box sx={{ mb: 1.5 }}>
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 600,
                              color: "text.primary",
                              mb: 1,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Icon
                              icon="eva:pricetags-outline"
                              width={20}
                              height={20}
                              style={{ marginRight: "8px" }}
                            />
                            Tags
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: "text.secondary",
                              fontSize: "0.875rem",
                            }}
                          >
                            Free-text labels/keywords for this charger (e.g.
                            "mall", "highway", "fast-charger"). Type a tag and
                            press Enter.
                          </Typography>
                        </Box>
                        <Autocomplete
                          multiple
                          freeSolo
                          options={[]}
                          value={values.tags || []}
                          onChange={(e, newValue) =>
                            setFieldValue("tags", newValue)
                          }
                          renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                              <Chip
                                label={option}
                                {...getTagProps({ index })}
                                key={`${option}-${index}`}
                              />
                            ))
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Tags"
                              placeholder="Add a tag…"
                            />
                          )}
                        />
                      </Card>
                    </Grid>

                    {/* Photo Upload Section */}
                    <Grid item xs={12} md={6}>
                      <Card
                        sx={{
                          p: 2,
                          borderRadius: 3,
                          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                          border: "1px solid rgba(0,0,0,0.05)",
                          background:
                            "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                          height: "fit-content",
                        }}
                      >
                        <Box sx={{ mb: 1.5 }}>
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 600,
                              color: "text.primary",
                              mb: 1,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Icon
                              icon="eva:camera-outline"
                              width={20}
                              height={20}
                              style={{ marginRight: "8px" }}
                            />
                            Station Photos
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: "text.secondary",
                              fontSize: "0.875rem",
                            }}
                          >
                            Upload photos to help users identify the location
                          </Typography>
                        </Box>

                        <Box
                          sx={{
                            border: "2px dashed rgba(25, 118, 210, 0.3)",
                            borderRadius: 3,
                            p: 2,
                            textAlign: "center",
                            background: "rgba(25, 118, 210, 0.02)",
                            transition: "all 0.3s ease",
                            "&:hover": {
                              borderColor: "rgba(25, 118, 210, 0.5)",
                              background: "rgba(25, 118, 210, 0.04)",
                            },
                          }}
                        >
                          <Stack direction="column" alignItems="center" gap={2}>
                            <Box
                              sx={{
                                width: 60,
                                height: 60,
                                borderRadius: "50%",
                                background:
                                  "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                mb: 1,
                              }}
                            >
                              <Icon
                                icon="eva:camera-outline"
                                width={30}
                                height={30}
                                color="#1976d2"
                              />
                            </Box>
                            <Typography
                              color="text.secondary"
                              textAlign="center"
                              variant="body2"
                              sx={{ fontWeight: 500 }}
                            >
                              Upload photos to help users identify the charging
                              station location
                            </Typography>
                            <LoadingButton
                              variant="contained"
                              onClick={() =>
                                imageUploadInputRef.current.click()
                              }
                              loading={imageUploadPending}
                              loadingIndicator="Uploading..."
                              startIcon={<Icon icon="eva:plus-outline" />}
                              sx={{
                                background:
                                  "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)",
                                boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)",
                                fontWeight: 600,
                                px: 3,
                                py: 1,
                                "&:hover": {
                                  background:
                                    "linear-gradient(135deg, #1565c0 0%, #1976d2 100%)",
                                  boxShadow:
                                    "0 6px 16px rgba(25, 118, 210, 0.4)",
                                  // Transform removed
                                },
                                // Transitions removed
                              }}
                            >
                              Upload Photos
                              <input
                                accept="image/jpeg,image/png,image/jpg"
                                type="file"
                                hidden
                                multiple
                                id="issue-image"
                                ref={imageUploadInputRef}
                                onChange={handleImageUpload}
                              />
                            </LoadingButton>
                          </Stack>
                        </Box>

                        {values.photos &&
                          values.photos.filter((url) => !is.empty(url)).length >
                          0 && (
                            <Box sx={{ mt: 3 }}>
                              <Typography
                                variant="subtitle2"
                                sx={{
                                  fontWeight: 600,
                                  color: "text.primary",
                                  mb: 2,
                                }}
                              >
                                Uploaded Photos
                              </Typography>
                              <ImageList cols={3} gap={8}>
                                {values.photos
                                  .filter((url) => !is.empty(url))
                                  .map((url, index) => (
                                    <ImageListItem 
                                      key={`${url}-${index}`}
                                      sx={{
                                        position: 'relative',
                                      }}
                                    >
                                      <img
                                        src={url}
                                        alt={`Station photo ${index + 1}`}
                                        style={{
                                          maxHeight: "120px",
                                          maxWidth: "100%",
                                          borderRadius: "8px",
                                          objectFit: "cover",
                                        }}
                                        loading="lazy"
                                      />
                                      <Tooltip title="Remove Photo" placement="top" arrow>
                                          <IconButton
                                            onClick={() => {
                                              const newPhotos = values.photos.filter((_, i) => i !== index);
                                              setFieldValue('photos', newPhotos);
                                            }}
                                            sx={{
                                              position: 'absolute',
                                              top: 6,
                                              right: 6,
                                              backgroundColor: 'rgba(0, 0, 0, 0.75)',
                                              color: 'white',
                                              padding: '6px',
                                              minWidth: 'auto',
                                              '&:hover': {
                                                backgroundColor: 'error.main',
                                                transform: 'scale(1.1)',
                                              },
                                              transition: 'all 0.2s ease',
                                            }}
                                          >
                                            <Icon icon={closeFill} width={20} height={20} />
                                          </IconButton>
                                      </Tooltip>
                                    </ImageListItem>
                                  ))}
                              </ImageList>
                            </Box>
                          )}
                      </Card>
                    </Grid>

                    {/* Contact Information Section */}
                    <Grid item xs={12}>
                      <Card
                        sx={{
                          p: 2,
                          borderRadius: 3,
                          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                          border: "1px solid rgba(0,0,0,0.05)",
                          background:
                            "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                        }}
                      >
                        <Box sx={{ mb: 1.5 }}>
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 600,
                              color: "text.primary",
                              mb: 1,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Icon
                              icon="eva:phone-outline"
                              width={20}
                              height={20}
                              style={{ marginRight: "8px" }}
                            />
                            Contact Information
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: "text.secondary",
                              fontSize: "0.875rem",
                            }}
                          >
                            Provide contact details for station operators
                          </Typography>
                        </Box>

                        <Grid container spacing={2}>
                          <Grid item xs={12} md={4}>
                            <TextField
                              label="Operator Number 1"
                              size="medium"
                              {...getFieldProps("operator_number1")}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  backgroundColor: "rgba(25, 118, 210, 0.02)",
                                  "&:hover .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#1976d2",
                                    borderWidth: 2,
                                  },
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    borderColor: "#1976d2",
                                    borderWidth: 2,
                                  },
                                },
                                "& .MuiInputLabel-root": {
                                  fontWeight: 500,
                                },
                              }}
                            />
                          </Grid>

                          <Grid item xs={12} md={4}>
                            <TextField
                              label="Operator Number 2"
                              size="medium"
                              {...getFieldProps("operator_number2")}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  backgroundColor: "rgba(25, 118, 210, 0.02)",
                                  "&:hover .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#1976d2",
                                    borderWidth: 2,
                                  },
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    borderColor: "#1976d2",
                                    borderWidth: 2,
                                  },
                                },
                                "& .MuiInputLabel-root": {
                                  fontWeight: 500,
                                },
                              }}
                            />
                          </Grid>

                          <Grid item xs={12} md={4}>
                            <TextField
                              label="Operator Email"
                              size="medium"
                              type="email"
                              {...getFieldProps("operator_email")}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  backgroundColor: "rgba(25, 118, 210, 0.02)",
                                  "&:hover .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#1976d2",
                                    borderWidth: 2,
                                  },
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    borderColor: "#1976d2",
                                    borderWidth: 2,
                                  },
                                },
                                "& .MuiInputLabel-root": {
                                  fontWeight: 500,
                                },
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                  </Grid>
                </Box>
              </TabPanel>

              <TabPanel value="settings">
                <Box sx={{ width: "100%", maxWidth: "100%" }}>
                  {/* Header Section */}
                  <Box
                    sx={{
                      mb: 2,
                      p: 2,
                      borderRadius: 3,
                      background:
                        "linear-gradient(135deg, #f8f9ff 0%, #e3f2fd 100%)",
                      border: "1px solid rgba(25, 118, 210, 0.1)",
                      boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                      <Box
                        sx={{
                          width: 48,
                          height: 48,
                          borderRadius: "50%",
                          background:
                            "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mr: 2,
                          boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)",
                        }}
                      >
                        <Icon
                          icon="eva:settings-outline"
                          width={24}
                          height={24}
                          color="white"
                        />
                      </Box>
                      <Box>
                        <Typography
                          variant="h5"
                          sx={{
                            fontWeight: 700,
                            color: "primary.main",
                            mb: 0.5,
                          }}
                        >
                          Charger Settings
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            color: "text.secondary",
                            fontWeight: 500,
                          }}
                        >
                          Configure payment options, notifications, and admin
                          settings
                        </Typography>
                      </Box>
                    </Box>
                  </Box>

                  {/* Settings Sections */}
                  <Grid container spacing={2}>
                    {/* Payment Options Section */}
                    <Grid item xs={12} md={6}>
                      <Card
                        sx={{
                          p: 2,
                          borderRadius: 3,
                          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                          border: "1px solid rgba(0,0,0,0.05)",
                          background:
                            "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                          height: "fit-content",
                        }}
                      >
                        <Box sx={{ mb: 1.5 }}>
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 600,
                              color: "text.primary",
                              mb: 1,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Icon
                              icon="eva:credit-card-outline"
                              width={20}
                              height={20}
                              style={{ marginRight: "8px" }}
                            />
                            Payment Options
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: "text.secondary",
                              fontSize: "0.875rem",
                            }}
                          >
                            Configure payment methods and access controls
                          </Typography>
                        </Box>

                        <Stack spacing={2}>
                          <Box
                            sx={{
                              p: 2,
                              borderRadius: 2,
                              border: "1px solid rgba(0,0,0,0.08)",
                              background: "rgba(0,0,0,0.02)",
                            }}
                          >
                            <FormControlLabel
                              control={
                                <Switch
                                  {...getFieldProps("employeeOrResident")}
                                  checked={!!values.employeeOrResident}
                                  sx={{
                                    "& .MuiSwitch-switchBase.Mui-checked": {
                                      color: "#1976d2",
                                    },
                                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                    {
                                      backgroundColor: "#1976d2",
                                    },
                                  }}
                                />
                              }
                              label={
                                <Box>
                                  <Typography
                                    sx={{ fontWeight: 500, fontSize: "0.9rem" }}
                                  >
                                    Employee / Resident (OTP)
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontSize: "0.75rem",
                                      color: "text.secondary",
                                    }}
                                  >
                                    Require OTP for employee/resident access
                                  </Typography>
                                </Box>
                              }
                              sx={{ m: 0, alignItems: "flex-start" }}
                            />
                          </Box>

                          <Box
                            sx={{
                              p: 2,
                              borderRadius: 2,
                              border: "1px solid rgba(0,0,0,0.08)",
                              background: "rgba(0,0,0,0.02)",
                            }}
                          >
                            <FormControlLabel
                              control={
                                <Switch
                                  {...getFieldProps("payWithWallet")}
                                  checked={!!values.payWithWallet}
                                  sx={{
                                    "& .MuiSwitch-switchBase.Mui-checked": {
                                      color: "#1976d2",
                                    },
                                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                    {
                                      backgroundColor: "#1976d2",
                                    },
                                  }}
                                />
                              }
                              label={
                                <Box>
                                  <Typography
                                    sx={{ fontWeight: 500, fontSize: "0.9rem" }}
                                  >
                                    Pay With Wallet
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontSize: "0.75rem",
                                      color: "text.secondary",
                                    }}
                                  >
                                    Allow payments using digital wallet
                                  </Typography>
                                </Box>
                              }
                              sx={{ m: 0, alignItems: "flex-start" }}
                            />
                          </Box>

                          <Box
                            sx={{
                              p: 2,
                              borderRadius: 2,
                              border: "1px solid rgba(0,0,0,0.08)",
                              background: "rgba(0,0,0,0.02)",
                            }}
                          >
                            <FormControlLabel
                              control={
                                <Switch
                                  {...getFieldProps("payWithCard")}
                                  checked={!!values.payWithCard}
                                  sx={{
                                    "& .MuiSwitch-switchBase.Mui-checked": {
                                      color: "#1976d2",
                                    },
                                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                    {
                                      backgroundColor: "#1976d2",
                                    },
                                  }}
                                />
                              }
                              label={
                                <Box>
                                  <Typography
                                    sx={{ fontWeight: 500, fontSize: "0.9rem" }}
                                  >
                                    Pay With Card
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontSize: "0.75rem",
                                      color: "text.secondary",
                                    }}
                                  >
                                    Allow payments using credit/debit cards
                                  </Typography>
                                </Box>
                              }
                              sx={{ m: 0, alignItems: "flex-start" }}
                            />
                          </Box>
                        </Stack>
                      </Card>
                    </Grid>

                    {/* Admin Settings Section */}
                    <Grid item xs={12} md={6}>
                      <Card
                        sx={{
                          p: 2,
                          borderRadius: 3,
                          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                          border: "1px solid rgba(0,0,0,0.05)",
                          background:
                            "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                          height: "fit-content",
                        }}
                      >
                        <Box sx={{ mb: 1.5 }}>
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 600,
                              color: "text.primary",
                              mb: 1,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Icon
                              icon="eva:settings-2-outline"
                              width={20}
                              height={20}
                              style={{ marginRight: "8px" }}
                            />
                            Admin Settings
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: "text.secondary",
                              fontSize: "0.875rem",
                            }}
                          >
                            Configure technical parameters and system behavior
                          </Typography>
                        </Box>

                        <Stack spacing={2}>
                          {isCreateCharger && (
                            <Typography 
                              variant="caption" 
                              sx={{ 
                                display: "flex", 
                                alignItems: "center",
                                gap: 1,
                                p: 1,
                                borderRadius: 1,
                                backgroundColor: "rgba(25, 118, 210, 0.05)",
                                color: "rgba(0, 0, 0, 0.6)",
                                border: "1px solid rgba(25, 118, 210, 0.1)",
                                fontSize: "0.75rem",
                                fontWeight: 500,
                                mb: 1
                              }}
                            >
                              <Icon icon="eva:info-outline" width={16} height={16} color="#1976d2" />
                              Tolerance will be auto-calculated and updated by the system on BootNotification after setting the meter interval on the charger.
                            </Typography>
                          )}

                          {/* Last Updated timestamp for tolerance fields */}
                          {values.tolerance_updated_at && (
                            <Typography
                              variant="caption"
                              sx={{
                                color: "primary.main",
                                fontSize: "0.75rem",
                                fontStyle: "italic",
                                mb: 0.5,
                              }}
                            >
                              Last updated on:{" "}
                              {values.tolerance_updated_at &&
                                format(
                                  convertUTCToLocal(values.tolerance_updated_at),
                                  "do MMMM yyyy 'at' hh:mm:ss a"
                                )}
                            </Typography>
                          )}
                          <TextField
                            required
                            disabled={isReadOnly}
                            label="Tolerance Level (Watts)"
                            size="medium"
                            type="number"
                            inputProps={{ min: 0, step: "1" }}
                            {...getFieldProps("tolerance_watt")}
                            error={Boolean(
                              touched.tolerance_watt && errors.tolerance_watt
                            )}
                            helperText={
                              touched.tolerance_watt && errors.tolerance_watt
                            }
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                backgroundColor: "rgba(25, 118, 210, 0.02)",
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "#1976d2",
                                  borderWidth: 2,
                                },
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  borderColor: "#1976d2",
                                  borderWidth: 2,
                                },
                              },
                              "& .MuiInputLabel-root": {
                                fontWeight: 500,
                              },
                            }}
                          />

                          <TextField
                            required
                            disabled={isReadOnly}
                            label="Meter Interval (Seconds)"
                            size="medium"
                            type="number"
                            inputProps={{ min: 0, step: "1" }}
                            {...getFieldProps("meter_interval_sec")}
                            error={Boolean(
                              touched.meter_interval_sec &&
                              errors.meter_interval_sec
                            )}
                            helperText={
                              touched.meter_interval_sec &&
                              errors.meter_interval_sec
                            }
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                backgroundColor: "rgba(25, 118, 210, 0.02)",
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "#1976d2",
                                  borderWidth: 2,
                                },
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  borderColor: "#1976d2",
                                  borderWidth: 2,
                                },
                              },
                              "& .MuiInputLabel-root": {
                                fontWeight: 500,
                              },
                            }}
                          />

                          <Box
                            sx={{
                              p: 2,
                              borderRadius: 2,
                              border: "1px solid rgba(0,0,0,0.08)",
                              background: "rgba(0,0,0,0.02)",
                            }}
                          >
                            <FormControlLabel
                              control={
                                <Switch
                                  {...getFieldProps("preparingState")}
                                  checked={!!values.preparingState}
                                  sx={{
                                    "& .MuiSwitch-switchBase.Mui-checked": {
                                      color: "#1976d2",
                                    },
                                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                    {
                                      backgroundColor: "#1976d2",
                                    },
                                  }}
                                />
                              }
                              label={
                                <Box>
                                  <Typography
                                    sx={{ fontWeight: 500, fontSize: "0.9rem" }}
                                  >
                                    Preparing State
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontSize: "0.75rem",
                                      color: "text.secondary",
                                    }}
                                  >
                                    Enable preparing state for charging sessions
                                  </Typography>
                                </Box>
                              }
                              sx={{ m: 0, alignItems: "flex-start" }}
                            />
                          </Box>
                        </Stack>
                      </Card>
                    </Grid>

                    {/* Notification Settings Section */}
                    <Grid item xs={12}>
                      <Card
                        sx={{
                          p: 2,
                          borderRadius: 3,
                          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                          border: "1px solid rgba(0,0,0,0.05)",
                          background:
                            "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                        }}
                      >
                        <Box sx={{ mb: 1.5 }}>
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 600,
                              color: "text.primary",
                              mb: 1,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Icon
                              icon="eva:email-outline"
                              width={20}
                              height={20}
                              style={{ marginRight: "8px" }}
                            />
                            Mail Notification Settings
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: "text.secondary",
                              fontSize: "0.875rem",
                            }}
                          >
                            Configure email notifications for charger events
                          </Typography>
                        </Box>

                        <Stack spacing={2}>
                          <Box
                            sx={{
                              p: 2,
                              borderRadius: 2,
                              border: "1px solid rgba(0,0,0,0.08)",
                              background: "rgba(0,0,0,0.02)",
                            }}
                          >
                            <FormControlLabel
                              control={
                                <Switch
                                  {...getFieldProps("enableNotifications")}
                                  checked={!!values.enableNotifications}
                                  sx={{
                                    "& .MuiSwitch-switchBase.Mui-checked": {
                                      color: "#1976d2",
                                    },
                                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                    {
                                      backgroundColor: "#1976d2",
                                    },
                                  }}
                                />
                              }
                              label={
                                <Box>
                                  <Typography
                                    sx={{ fontWeight: 500, fontSize: "0.9rem" }}
                                  >
                                    Enable Notifications
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontSize: "0.75rem",
                                      color: "text.secondary",
                                    }}
                                  >
                                    Send email notifications for charger events
                                  </Typography>
                                </Box>
                              }
                              sx={{ m: 0, alignItems: "flex-start" }}
                            />
                          </Box>

                          {values?.enableNotifications && (
                            <>
                              <TextField
                                required
                                multiline
                                rows={4}
                                label="Notification Recipients"
                                placeholder="Enter email addresses separated by commas"
                                {...getFieldProps("notificationRecipients")}
                                error={Boolean(
                                  touched.notificationRecipients &&
                                  errors.notificationRecipients
                                )}
                                helperText={
                                  touched.notificationRecipients &&
                                  errors.notificationRecipients
                                }
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    backgroundColor: "rgba(25, 118, 210, 0.02)",
                                    "&:hover .MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: "#1976d2",
                                      borderWidth: 2,
                                    },
                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: "#1976d2",
                                      borderWidth: 2,
                                    },
                                  },
                                  "& .MuiInputLabel-root": {
                                    fontWeight: 500,
                                  },
                                }}
                              />

                              {whatsappEnabled && (
                                <TextField
                                  label="WhatsApp Phone Number"
                                  placeholder="e.g. +14155551234"
                                  {...getFieldProps("whatsappPhone")}
                                  error={Boolean(
                                    touched.whatsappPhone && errors.whatsappPhone
                                  )}
                                  helperText={
                                    (touched.whatsappPhone &&
                                      errors.whatsappPhone) ||
                                    "A single number (E.164). WhatsApp is sent only for Charger Boot, Connector Faulted and Station Disconnected; all other events are email-only."
                                  }
                                  sx={{
                                    "& .MuiOutlinedInput-root": {
                                      backgroundColor: "rgba(37, 211, 102, 0.04)",
                                    },
                                    "& .MuiInputLabel-root": {
                                      fontWeight: 500,
                                    },
                                  }}
                                />
                              )}

                              <Box>
                                <Typography
                                  variant="subtitle2"
                                  sx={{
                                    fontWeight: 600,
                                    color: "text.primary",
                                    mb: 2,
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Icon
                                    icon="eva:bell-outline"
                                    width={16}
                                    height={16}
                                    style={{ marginRight: "8px" }}
                                  />
                                  Notification Events
                                </Typography>

                                <Grid container spacing={2}>
                                  {[
                                    {
                                      key: "OcppStationBooted",
                                      label: "Boot Notification Sent",
                                      description: "When charger boots up",
                                      whatsapp: true,
                                    },
                                    {
                                      key: "OcppStationStatusFailure",
                                      label: "Connector Faulted",
                                      description:
                                        "When a connector gets faulted",
                                      whatsapp: true,
                                    },
                                    {
                                      key: "OcppStationWebSocketConnected",
                                      label: "Station Connected",
                                      description:
                                        "When charging station connects",
                                    },
                                    {
                                      key: "OcppStationWebSocketDisconnected",
                                      label: "Station Disconnected",
                                      description:
                                        "When charging station disconnects",
                                      whatsapp: true,
                                    },
                                    {
                                      key: "OcppTransactionStarted",
                                      label: "Transaction Started",
                                      description:
                                        "When a charging transaction starts",
                                    },
                                    {
                                      key: "OcppTransactionEnded",
                                      label: "Transaction Ended",
                                      description:
                                        "When a charging transaction stops",
                                    },
                                  ].map(({ key, label, description, whatsapp }) => (
                                    <Grid item xs={12} md={6} key={key}>
                                      <Box
                                        sx={{
                                          p: 2,
                                          borderRadius: 2,
                                          border: "1px solid rgba(0,0,0,0.08)",
                                          background: "rgba(0,0,0,0.02)",
                                          transition: "all 0.3s ease",
                                        }}
                                      >
                                        <FormControlLabel
                                          control={
                                            <Switch
                                              {...getFieldProps(key)}
                                              checked={!!values[key]}
                                              sx={{
                                                "& .MuiSwitch-switchBase.Mui-checked":
                                                {
                                                  color: "#1976d2",
                                                },
                                                "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                                {
                                                  backgroundColor: "#1976d2",
                                                },
                                              }}
                                            />
                                          }
                                          label={
                                            <Box>
                                              <Box
                                                sx={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: 0.75,
                                                }}
                                              >
                                                <Typography
                                                  sx={{
                                                    fontWeight: 500,
                                                    fontSize: "0.9rem",
                                                  }}
                                                >
                                                  {label}
                                                </Typography>
                                                {whatsapp && whatsappEnabled && (
                                                  <Chip
                                                    size="small"
                                                    icon={
                                                      <Icon icon="logos:whatsapp-icon" />
                                                    }
                                                    label="WhatsApp"
                                                    sx={{
                                                      height: 20,
                                                      fontSize: "0.65rem",
                                                      fontWeight: 600,
                                                      bgcolor:
                                                        "rgba(37, 211, 102, 0.15)",
                                                      color: "#128C7E",
                                                      "& .MuiChip-icon": {
                                                        fontSize: "0.8rem",
                                                      },
                                                    }}
                                                  />
                                                )}
                                              </Box>
                                              <Typography
                                                sx={{
                                                  fontSize: "0.75rem",
                                                  color: "text.secondary",
                                                }}
                                              >
                                                {description}
                                              </Typography>
                                            </Box>
                                          }
                                          sx={{
                                            m: 0,
                                            alignItems: "flex-start",
                                          }}
                                        />
                                      </Box>
                                    </Grid>
                                  ))}
                                </Grid>
                              </Box>
                            </>
                          )}
                        </Stack>
                      </Card>
                    </Grid>

                    {/* OCPP Security Section */}
                    <Grid item xs={12} md={6}>
                      <Card
                        sx={{
                          p: 2,
                          borderRadius: 3,
                          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                          border: "1px solid rgba(0,0,0,0.05)",
                          background: "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                          height: "fit-content",
                        }}
                      >
                        <Box sx={{ mb: 1.5 }}>
                          <Typography
                            variant="h6"
                            sx={{ fontWeight: 600, color: "text.primary", mb: 1, display: "flex", alignItems: "center" }}
                          >
                            <Icon icon="eva:shield-outline" width={20} height={20} style={{ marginRight: "8px" }} />
                            OCPP Security
                          </Typography>
                          <Typography variant="body2" sx={{ color: "text.secondary", fontSize: "0.875rem" }}>
                            How this charger must authenticate when it connects to the CMS
                          </Typography>
                          {!isReadOnly && !isGrandParent && (
                            <Typography
                              variant="caption"
                              sx={{ color: "text.secondary", display: "flex", alignItems: "center", mt: 0.5 }}
                            >
                              <Icon icon="eva:lock-outline" width={14} height={14} style={{ marginRight: 4 }} />
                              Only a super admin can change OCPP security.
                            </Typography>
                          )}
                        </Box>
                        <Stack spacing={2}>
                          <FormControl fullWidth size="small">
                            <InputLabel id="ocpp_auth_mode" sx={{ fontWeight: 600, color: "text.secondary" }}>
                              Authentication
                            </InputLabel>
                            <Select
                              labelId="ocpp_auth_mode"
                              id="ocpp_auth_mode"
                              disabled={ocppSecurityReadOnly}
                              label="Authentication"
                              {...getFieldProps("ocpp_auth_mode")}
                              sx={{ borderRadius: 2 }}
                            >
                              {OCPP_AUTH_MODE_OPTIONS.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                  {option.label}
                                </MenuItem>
                              ))}
                            </Select>
                            <FormHelperText>
                              {OCPP_AUTH_MODE_OPTIONS.find((o) => o.value === values.ocpp_auth_mode)?.description}
                            </FormHelperText>
                          </FormControl>

                          {values.ocpp_auth_mode !== "NONE" && (
                            <>
                              <TextField
                                fullWidth
                                size="small"
                                disabled={ocppSecurityReadOnly}
                                autoComplete="new-password"
                                label={values.hasOcppAuthPassword ? "New password (optional)" : "Password *"}
                                type={showOcppPassword ? "text" : "password"}
                                {...getFieldProps("ocpp_auth_password")}
                                error={Boolean(shouldShowError("ocpp_auth_password"))}
                                helperText={
                                  shouldShowError("ocpp_auth_password") ||
                                  (values.hasOcppAuthPassword
                                    ? "A password is set. Leave empty to keep it."
                                    : "16-40 characters. Configure the same password on the charger.")
                                }
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <Tooltip title={showOcppPassword ? "Hide" : "Show"}>
                                        <IconButton
                                          size="small"
                                          onClick={() => setShowOcppPassword((s) => !s)}
                                          edge="end"
                                        >
                                          <Icon icon={showOcppPassword ? "eva:eye-off-outline" : "eva:eye-outline"} />
                                        </IconButton>
                                      </Tooltip>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                              {!ocppSecurityReadOnly && (
                                <Box>
                                  <Button
                                    size="small"
                                    variant="outlined"
                                    startIcon={<Icon icon="eva:refresh-outline" />}
                                    onClick={() => {
                                      // 24 chars from a set without ':' / quotes / spaces, which
                                      // some charger config UIs reject. Uses the browser's CSPRNG.
                                      const alphabet =
                                        "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789-_.!@#";
                                      const bytes = new Uint32Array(24);
                                      window.crypto.getRandomValues(bytes);
                                      const generated = Array.from(bytes, (b) => alphabet[b % alphabet.length]).join("");
                                      setFieldValue("ocpp_auth_password", generated);
                                      setShowOcppPassword(true);
                                    }}
                                  >
                                    Generate password
                                  </Button>
                                </Box>
                              )}
                              <Alert severity="info" sx={{ borderRadius: 2 }}>
                                The charger must be configured to use Charger ID{" "}
                                <strong>{values.chargepoint_id || "(this charger's ID)"}</strong> as the username and
                                this password
                                {values.ocpp_auth_mode === "BASIC_TLS" ? ", and to connect over wss:// (TLS)" : ""}.
                                Until then it will be refused when it reconnects.
                              </Alert>
                            </>
                          )}
                        </Stack>
                      </Card>
                    </Grid>
                  </Grid>
                </Box>
              </TabPanel>
              <TabPanel value="config"></TabPanel>

              <TabPanel value="logs">
                <Box
                  sx={{
                    width: "100%",
                    maxWidth: "100%",
                    overflow: "visible",
                  }}
                >
                  {/* Search Controls */}
                  <Card
                    sx={{
                      p: 2,
                      mb: 1.5,
                      borderRadius: 3,
                      boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                      border: "1px solid rgba(0,0,0,0.05)",
                      background:
                        "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                    }}
                  >
                    {/* Quick range presets: Live (auto-refresh) + last N minutes */}
                    <Box
                      sx={{
                        display: "flex",
                        gap: 1,
                        flexWrap: "wrap",
                        alignItems: "center",
                        mb: 1.5,
                      }}
                    >
                      <Chip
                        label={
                          !hasTimeFilter
                            ? livePolling
                              ? "🔴 Live"
                              : "⏸ Live (paused)"
                            : "Live"
                        }
                        onClick={goLive}
                        color={!hasTimeFilter ? "error" : "default"}
                        variant={!hasTimeFilter ? "filled" : "outlined"}
                        size="small"
                      />
                      {!hasTimeFilter && (
                        <Chip
                          label={livePolling ? "Pause" : "Resume"}
                          onClick={() => setLivePolling((p) => !p)}
                          variant="outlined"
                          size="small"
                        />
                      )}
                      <Divider orientation="vertical" flexItem sx={{ mx: 0.5 }} />
                      {[
                        { l: "5m", m: 5 },
                        { l: "15m", m: 15 },
                        { l: "30m", m: 30 },
                        { l: "1h", m: 60 },
                        { l: "6h", m: 360 },
                        { l: "24h", m: 1440 },
                      ].map((o) => (
                        <Chip
                          key={o.m}
                          label={`Last ${o.l}`}
                          onClick={() => applyLogRange(o.m)}
                          color={
                            hasTimeFilter && logRangePreset === String(o.m)
                              ? "primary"
                              : "default"
                          }
                          variant={
                            hasTimeFilter && logRangePreset === String(o.m)
                              ? "filled"
                              : "outlined"
                          }
                          size="small"
                        />
                      ))}
                    </Box>
                    <Stack
                      direction={{ xs: "column", md: "row" }}
                      alignItems="flex-start"
                      justifyContent="space-between"
                      spacing={2}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          gap: 2,
                          alignItems: "flex-start",
                          flexWrap: "wrap",
                          flex: 1,
                        }}
                      >
                        <Box
                          sx={{ minWidth: { xs: "100%", sm: 200, md: 220 } }}
                        >
                          <DateTimePicker
                            size="small"
                            label="Start Date/Time"
                            value={timeInterval.startDate}
                            maxDate={new Date()}
                            error={Boolean(timeInterval.startDate && new Date(timeInterval.startDate) > new Date())}
                            helperText={timeInterval.startDate && new Date(timeInterval.startDate) > new Date() ? "Start time cannot be in the future" : ""}
                            onChange={(newValue) => {
                              setTimeInterval((prev) => ({
                                ...prev,
                                startDate: newValue,
                              }));
                            }}
                          />
                        </Box>
                        <Box
                          sx={{ minWidth: { xs: "100%", sm: 200, md: 220 } }}
                        >
                          <DateTimePicker
                            size="small"
                            label="End Date/Time"
                            value={timeInterval.endDate}
                            maxDate={
                              timeInterval.startDate
                                ? new Date(
                                    Math.min(
                                      new Date().getTime(),
                                      new Date(timeInterval.startDate).getTime() +
                                        24 * 60 * 60 * 1000
                                    )
                                  )
                                : new Date()
                            }
                            minDate={timeInterval.startDate ? new Date(timeInterval.startDate) : undefined}
                            error={
                              Boolean(timeInterval.endDate && new Date(timeInterval.endDate) > new Date()) ||
                              Boolean(timeInterval.startDate && timeInterval.endDate && new Date(timeInterval.endDate) < new Date(timeInterval.startDate)) ||
                              Boolean(timeInterval.startDate && timeInterval.endDate && (new Date(timeInterval.endDate) - new Date(timeInterval.startDate)) > 24 * 60 * 60 * 1000)
                            }
                            helperText={
                              timeInterval.endDate && new Date(timeInterval.endDate) > new Date()
                                ? "End time cannot be in the future"
                                : timeInterval.startDate && timeInterval.endDate && new Date(timeInterval.endDate) < new Date(timeInterval.startDate)
                                ? "End time must be after start time"
                                : timeInterval.startDate && timeInterval.endDate && (new Date(timeInterval.endDate) - new Date(timeInterval.startDate)) > 24 * 60 * 60 * 1000
                                ? "Range must not exceed 1 day (24 hours)"
                                : ""
                            }
                            onChange={(newValue) => {
                              setTimeInterval((prev) => ({
                                ...prev,
                                endDate: newValue,
                              }));
                            }}
                          />
                        </Box>
                        <LoadingButton
                          variant="contained"
                          loading={isLogsFetching || isLogsRefetching || isFetchingLogs}
                          disabled={
                            isLogsFetching || 
                            isLogsRefetching || 
                            isFetchingLogs || 
                            (!timeInterval.startDate && !timeInterval.endDate) ||
                            (timeInterval.startDate && new Date(timeInterval.startDate) > new Date()) ||
                            (timeInterval.endDate && new Date(timeInterval.endDate) > new Date()) ||
                            (timeInterval.startDate && timeInterval.endDate && new Date(timeInterval.endDate) < new Date(timeInterval.startDate))
                          }
                          onClick={() => {
                            // Set time filter as active when user searches
                            setHasTimeFilter(true);
                            // Manual date range = custom (no preset chip highlighted)
                            setLogRangePreset("CUSTOM");
                            // Pass Date objects directly - fetchLogFilterData will handle UTC conversion
                            fetchLogFilterData(
                              timeInterval.startDate,
                              timeInterval.endDate
                            );
                          }}
                          sx={{
                            background:
                              "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)",
                            boxShadow: "0 2px 8px rgba(25, 118, 210, 0.3)",
                            minWidth: { xs: "100%", sm: "120px" },
                            height: { xs: "40px", sm: "36px" },
                            fontSize: { xs: "0.875rem", sm: "0.8rem" },
                            fontWeight: 600,
                            "&:hover": {
                              background:
                                "linear-gradient(135deg, #1565c0 0%, #1976d2 100%)",
                              boxShadow: "0 4px 12px rgba(25, 118, 210, 0.4)",
                              // Transform removed
                            },
                            "&.Mui-disabled": {
                              background: "linear-gradient(135deg, #90caf9 0%, #b3e5fc 100%)",
                              color: "rgba(126, 126, 126, 0.7)",
                            },
                            // Transitions removed
                          }}
                        >
                          {isLogsFetching || isLogsRefetching || isFetchingLogs ? "Loading..." : "Search"}
                        </LoadingButton>
                        <Button
                          variant="outlined"
                          disabled={isLogsFetching || isLogsRefetching || isFetchingLogs || isFetchingNextPage}
                          onClick={() => {
                            const wasFiltered = hasTimeFilter;
                            // 1. Clear local state (return to Live)
                            setHasTimeFilter(false);
                            setLogRangePreset("LIVE");
                            setLivePolling(true);
                            setTimeInterval({ startDate: "", endDate: "" });
                            setLogDetailData(null);
                            setLogWindowParams(null);

                            // 2. FORCE clear the dataForLogs in Redux (create a clean object without the property)
                            if (reduxData) {
                              const newReduxData = { ...reduxData };
                              delete newReduxData.dataForLogs; // Explicitly delete the property
                              
                              dispatch(
                                tabsCurrentlyOpenedForSlice.actions.setTabsOpened({
                                  detailsId: charger?.chargepoint_id,
                                  tabOpenedFor,
                                  tabOpened,
                                  data: newReduxData,
                                })
                              );
                            }

                            // 3. Refetch
                            if (wasFiltered) {
                              refetch();
                            }
                          }}
                          sx={{
                            background:
                              "linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%)",
                            visibility: (hasTimeFilter || timeInterval.startDate || timeInterval.endDate) ? "visible" : "hidden",
                            borderColor: "#9e9e9e",
                            color: "#424242",
                            minWidth: { xs: "100%", sm: "120px" },
                            height: { xs: "40px", sm: "36px" },
                            fontSize: { xs: "0.875rem", sm: "0.8rem" },
                            fontWeight: 600,
                            "&:hover": {
                              background:
                                "linear-gradient(135deg, #e0e0e0 0%, #bdbdbd 100%)",
                              borderColor: "#757575",
                              color: "#212121",
                            },
                            "&.Mui-disabled": {
                              background: "rgba(0, 0, 0, 0.04)",
                              borderColor: "rgba(0, 0, 0, 0.12)",
                              color: "rgba(0, 0, 0, 0.26)",
                            },
                          }}
                        >
                          Clear Filter
                        </Button>
                      </Box>
                      <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                        {(logDetailData?.pages?.[0]?.length > 0 || logsData?.pages?.[0]?.length > 0) && (
                          <Tooltip title="Export CSV">
                            <span>
                              <IconButton
                                onClick={handleExport}
                                disabled={isLogsFetching || isLogsRefetching || isFetchingLogs || isFetchingNextPage}
                                sx={{
                                  bgcolor: "success.main",
                                  color: "white",
                                  "&:hover": {
                                    bgcolor: "success.dark",
                                  },
                                  "&:disabled": {
                                    bgcolor: "grey.300",
                                    color: "grey.500",
                                  },
                                }}
                              >
                                <Icon
                                  icon={downloadFill}
                                  width={20}
                                  height={20}
                                />
                              </IconButton>
                            </span>
                          </Tooltip>
                        )}
                        <Tooltip title="Refresh data">
                          <span>
                            <IconButton
                              onClick={handleRefetch}
                              disabled={isLogsFetching || isLogsRefetching || isFetchingLogs}
                              sx={{
                                bgcolor: "primary.main",
                                color: "white",
                                "&:hover": {
                                  bgcolor: "primary.dark",
                                },
                                "&:disabled": {
                                  bgcolor: "grey.300",
                                  color: "grey.500",
                                },
                              }}
                            >
                              <Icon icon={RefreshFill} width={20} height={20} />
                            </IconButton>
                          </span>
                        </Tooltip>
                      </Box>
                    </Stack>
                  </Card>

                  {/* Enhanced Logs Content */}
                  <Box
                    sx={{
                      borderRadius: 3,
                      overflow: "visible",
                      boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                      border: "1px solid rgba(0,0,0,0.05)",
                      background:
                        "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                      position: "relative",
                      minHeight: 200,
                    }}
                  >
                    {((isLogsFetching || isLogsRefetching || isFetchingLogs) && !((hasTimeFilter ? logDetailData : logsData)?.pages?.[0]?.length > 0)) ? (
                      <Box
                        sx={{
                          p: 6,
                          textAlign: "center",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Box
                          sx={{
                            width: 80,
                            height: 80,
                            borderRadius: "50%",
                            background: "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            mx: "auto",
                            mb: 2,
                          }}
                        >
                          <CircularProgress size={40} sx={{ color: "#1976d2" }} />
                        </Box>
                        <Typography variant="h6" sx={{ fontWeight: 600, color: "#1976d2", mb: 1 }}>
                          Loading Logs...
                        </Typography>
                        <Typography variant="body2" sx={{ color: "text.secondary", opacity: 0.8 }}>
                          Please wait while we fetch the data
                        </Typography>
                      </Box>
                    ) : (((hasTimeFilter ? logDetailData : logsData)?.pages?.[0]?.length > 0) || logFilterQuery !== "") ? (
                      // Keep the logs viewer (and its filter bar + Clear filters button)
                      // mounted whenever a filter is active, even with zero results —
                      // otherwise a filter that matches nothing leaves the user with no
                      // way to change or clear it.
                      <EnhancedLogsData
                        data={hasTimeFilter ? logDetailData : logsData}
                        fetchNextPage={fetchNextPage}
                        hasNextPage={hasNextPage}
                        isFetchingNextPage={isFetchingNextPage}
                        hasTimeFilter={hasTimeFilter}
                        onExport={getFilteredLogsRef}
                        filters={logFilters}
                        onFilterChange={(patch) =>
                          setLogFilters((prev) => ({ ...prev, ...patch }))
                        }
                        connectors={values.connectors}
                        logCounts={logCounts}
                      />
                    ) : !(isLogsFetching || isLogsRefetching || isFetchingLogs) ? (
                      <Box
                        sx={{
                          p: 6,
                          textAlign: "center",
                        }}
                      >
                        <Box
                          sx={{
                            width: 80,
                            height: 80,
                            borderRadius: "50%",
                            background:
                              "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            mx: "auto",
                            mb: 2,
                          }}
                        >
                          <Icon
                            icon="eva:file-text-outline"
                            width={40}
                            height={40}
                            style={{ color: "#1976d2" }}
                          />
                        </Box>
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 600,
                            color: "#1976d2",
                            mb: 1,
                          }}
                        >
                          No Logs Found
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            color: "text.secondary",
                            opacity: 0.8,
                          }}
                        >
                          Try adjusting your date range or search criteria
                        </Typography>
                      </Box>
                    ) : null}
                  </Box>
                </Box>
              </TabPanel>

              <TabPanel value="status_history">
                <Box sx={{ width: "100%", maxWidth: "100%", overflow: "visible" }}>
                  <Card
                    sx={{
                      p: 2,
                      mb: 2,
                      borderRadius: 3,
                      boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                    }}
                  >
                    <Stack spacing={2}>
                      <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        flexWrap="wrap"
                        gap={1}
                      >
                        <Typography variant="subtitle1" fontWeight={600}>
                          Connector Status History
                        </Typography>
                        {connectorOptions.length > 1 && (
                          <FormControl size="small" sx={{ minWidth: 220, maxWidth: 360 }}>
                            <InputLabel id="status-history-connector-label">
                              Connector
                            </InputLabel>
                            <Select
                              labelId="status-history-connector-label"
                              label="Connector"
                              value={
                                statusHistoryConnectorId ||
                                connectorOptions[0]?.connectorId ||
                                ""
                              }
                              onChange={handleStatusHistoryConnectorChange}
                            >
                              {connectorOptions.map((option) => (
                                <MenuItem
                                  key={option.connectorId}
                                  value={option.connectorId}
                                >
                                  {option.label}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        )}
                      </Stack>

                      {statusHistoryError ? (
                        <Alert severity="error">{statusHistoryError}</Alert>
                      ) : (
                        <BaseTable
                          rows={normalizedStatusHistory}
                          columns={statusHistoryColumns}
                          loading={statusHistoryLoading}
                          getRowId={(row) => row.id}
                          showExportCsvBtn={false}
                          csvMorphemes="status-history"
                          isReadOnly
                          paginationMode="server"
                          rowCount={statusHistoryTotal}
                          page={statusHistoryPage}
                          pageSize={statusHistoryPageSize}
                          rowsPerPageOptions={[10, 20, 50]}
                          onPageChange={(newPage) => setStatusHistoryPage(newPage)}
                          onPageSizeChange={(newSize) => {
                            setStatusHistoryPageSize(newSize);
                            setStatusHistoryPage(0);
                          }}
                        />
                      )}
                    </Stack>
                  </Card>
                </Box>
              </TabPanel>

              <TabPanel value="operating_instruction">
                <Grid container spacing={2} className="mb-5">
                  <Grid item xs={12} lg={12} marginBottom={2}>
                    <Typography
                      sx={{ ml: 2 }}
                      variant="subtitle1"
                      className="mb-2 text-uppercase"
                    >
                      FAQ
                    </Typography>
                    <Divider className="text-muted" variant="middle" />
                  </Grid>
                  <Grid item xs={12} lg={12} textAlign="right">
                    {values?.faq?.length !== 10 && (
                      <Grid item xs={12} lg={12} sm={12}>
                        <Tooltip
                          title="Add More Connectors"
                          placement="right-end"
                        >
                          <LoadingButton
                            size="medium"
                            type="button"
                            variant="contained"
                            onClick={() => handleAddAndDeleteFAQ()}
                          >
                            <Icon
                              icon={PlusFill}
                              fontSize="1.9em"
                              className="fs-5"
                            />
                          </LoadingButton>
                        </Tooltip>
                      </Grid>
                    )}
                  </Grid>
                  {values?.faq?.map((value, i) => (
                    <Fragment key={`faq-${i}`}>
                      <Grid item xs={6} lg={6}>
                        <Stack direction="column" gap={2}>
                          <FormControl fullWidth size="small">
                            <Field name={`faq[${i}].id`}>
                              {({ field }) => (
                                <input type="hidden" {...field} />
                              )}
                            </Field>
                            <Field name={`faq[${i}].question`}>
                              {({ field, form: { touched, errors } }) => (
                                <TextField
                                  disabled={isReadOnly}
                                  label={`Question-${i + 1}`}
                                  size="small"
                                  {...field}
                                  error={touched.question && errors.question}
                                />
                              )}
                            </Field>
                          </FormControl>
                          <FormControl fullWidth size="small">
                            <Field name={`faq[${i}].answer`}>
                              {({ field, form: { touched, errors } }) => (
                                <TextField
                                  multiline
                                  rows={4}
                                  id=""
                                  label={`Answer-${i + 1}`}
                                  error={touched.answer && errors.answer}
                                  {...field}
                                />
                              )}
                            </Field>
                          </FormControl>
                        </Stack>
                      </Grid>
                    </Fragment>
                  ))}
                </Grid>
              </TabPanel>

              <TabPanel value="report_incidents">
                <Grid container spacing={2} className="mb-5">
                  <Grid item xs={12} lg={12} marginBottom={2}>
                    <Typography
                      sx={{ ml: 2 }}
                      variant="subtitle1"
                      className="mb-2 text-uppercase"
                    >
                      REPORT INCIDENTS
                    </Typography>
                    <Divider className="text-muted" variant="middle" />
                  </Grid>
                  <Grid item xs={12} lg={12}>
                    <BaseTable
                      rows={values.report_issues ?? []}
                      columns={reportIssuesColumn}
                      loading={isFetching}
                      getRowId={(row) => row.serial_number}
                      showExportCsvBtn={false}
                      csvMorphemes="chargers"
                      pageSize={10}
                      isReadOnly={isReadOnly}
                    />
                  </Grid>
                </Grid>
              </TabPanel>
              {!hideForTabs.includes(selectedTab) && (
                <Stack
                  direction="row"
                  spacing={2}
                  alignItems="center"
                  justifyContent="center"
                >
                  {!isReadOnly && (
                    <>
                      <Button
                        size="medium"
                        type="button"
                        variant="outlined"
                        component={RouterLink}
                        to="/charger"
                        startIcon={<Icon icon="eva:close-outline" />}
                        sx={{
                          px: 3,
                          py: 1,
                          textTransform: "none",
                          fontWeight: 500,
                        }}
                      >
                        Cancel
                      </Button>
                      <LoadingButton
                        size="medium"
                        type="submit"
                        variant="contained"
                        disabled={isReadOnly}
                        loading={isSubmitting || isLoading}
                        startIcon={<Icon icon="eva:save-outline" />}
                        sx={{
                          px: 3,
                          py: 1,
                          textTransform: "none",
                          fontWeight: 500,
                        }}
                      >
                        {isSubmitting || isLoading
                          ? "Saving..."
                          : "Save Changes"}
                      </LoadingButton>
                    </>
                  )}
                </Stack>
              )}
            </Form>
          </FormikProvider>

          {razorPayQRCodePreview.open && (
            <ImgPreviewModal
              imageObj={razorPayQRCodePreview}
              buttonsArray={
                razorPayQRCodePreview.type === "upi"
                  ? [
                    {
                      btnLabel: "Download",
                      action: () => downloadUPIQRFromModal(razorPayQRCodePreview.value, razorPayQRCodePreview.logoUrl),
                      params: false,
                    },
                    {
                      btnLabel: "Close",
                      action: function () {
                        setRazorPayQRCodePreview({ ...razorPayQRCodePreview, open: false });
                      },
                    },
                  ]
                  : razorPayQRCodePreview.buttons
              }
            />
          )}
          {CMQRCodePreview.open && (
            <ImgPreviewModal
              imageObj={CMQRCodePreview}
              buttonsArray={CMQRCodePreview.buttons}
            />
          )}
          <TabPanel value="remote operations">
            <Box sx={{ width: "100%", maxWidth: "100%" }}>
              {/* Header Section */}
              <Box
                sx={{
                  mb: 2,
                  p: 3,
                  borderRadius: 3,
                  background:
                    "linear-gradient(135deg, #f8f9ff 0%, #e3f2fd 100%)",
                  border: "1px solid rgba(25, 118, 210, 0.1)",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  <Box
                    sx={{
                      width: 48,
                      height: 48,
                      borderRadius: "50%",
                      background:
                        "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mr: 2,
                      boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)",
                    }}
                  >
                    <Icon
                      icon="eva:settings-outline"
                      width={24}
                      height={24}
                      color="white"
                    />
                  </Box>
                  <Box>
                    <Typography
                      variant="h5"
                      sx={{
                        fontWeight: 700,
                        color: "primary.main",
                        mb: 0.5,
                      }}
                    >
                      Remote Operations
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "text.secondary",
                        fontWeight: 500,
                      }}
                    >
                      Control and manage charger operations remotely
                    </Typography>
                  </Box>
                </Box>
              </Box>

              {/* Main Content */}
              <Grid container spacing={2}>
                {/* Operation Selection Panel */}
                <Grid item xs={12} md={4}>
                  <Card
                    sx={{
                      p: 2,
                      borderRadius: 3,
                      boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                      border: "1px solid rgba(0,0,0,0.05)",
                      background:
                        "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                      height: "fit-content",
                    }}
                  >
                    <Box sx={{ mb: 3 }}>
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 600,
                          color: "text.primary",
                          mb: 1,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Icon
                          icon="eva:radio-button-on-outline"
                          width={20}
                          height={20}
                          style={{ marginRight: "8px" }}
                        />
                        Select Operation
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "text.secondary",
                          fontSize: "0.875rem",
                        }}
                      >
                        Choose the operation you want to perform
                      </Typography>
                    </Box>

                    <FormControl fullWidth>
                      <RadioGroup
                        aria-labelledby="Remote-Operations-Radio-Btns-Group-Label"
                        onChange={(event, newValue) => {
                          setOperation(newValue);
                        }}
                        value={operation}
                        name="remote-operations-radio-buttons-group"
                        sx={{ gap: 1 }}
                      >
                        {remoteOperations &&
                          remoteOperations.map(({ label, value }) => (
                            <FormControlLabel
                              key={value}
                              value={value}
                              control={
                                <Radio
                                  sx={{
                                    color: "primary.main",
                                    "&.Mui-checked": {
                                      color: "primary.main",
                                    },
                                    "& .MuiSvgIcon-root": {
                                      fontSize: 20,
                                    },
                                  }}
                                />
                              }
                              label={
                                <Typography
                                  sx={{
                                    fontWeight: 500,
                                    fontSize: "0.9rem",
                                    color: "text.primary",
                                  }}
                                >
                                  {label}
                                </Typography>
                              }
                              sx={{
                                m: 0,
                                p: 1.5,
                                borderRadius: 2,
                                border: "1px solid transparent",
                                // Transitions removed
                                "&:hover": {
                                  backgroundColor: "rgba(25, 118, 210, 0.04)",
                                  borderColor: "rgba(25, 118, 210, 0.1)",
                                },
                                "&.Mui-checked": {
                                  backgroundColor: "rgba(25, 118, 210, 0.08)",
                                  borderColor: "rgba(25, 118, 210, 0.2)",
                                },
                              }}
                            />
                          ))}
                      </RadioGroup>
                    </FormControl>
                  </Card>
                </Grid>

                {/* Operation Form Panel */}
                <Grid item xs={12} md={8}>
                  {operation && validationSchema && (
                    <Card
                      sx={{
                        p: 2,
                        borderRadius: 3,
                        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                        border: "1px solid rgba(0,0,0,0.05)",
                        background:
                          "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                        minHeight: "400px",
                      }}
                    >
                      <Box sx={{ mb: 1.5 }}>
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 600,
                            color: "text.primary",
                            mb: 1,
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Icon
                            icon="eva:edit-outline"
                            width={20}
                            height={20}
                            style={{ marginRight: "8px" }}
                          />
                          Operation Configuration
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            color: "text.secondary",
                            fontSize: "0.875rem",
                          }}
                        >
                          Configure parameters for the selected operation
                        </Typography>
                      </Box>

                      <RemoteOperationForm
                        operation={operation}
                        validationSchema={validationSchema}
                        initialValues={initialValues}
                        chargerId={values.chargepoint_id}
                        chargerPk={id}
                        chargerName={values.chargepoint_name}
                        key={operation}
                        queryKeysDropdown={queryKeysDropdown}
                      />
                    </Card>
                  )}

                  {/* Empty State */}
                  {(!operation || !validationSchema) && (
                    <Card
                      sx={{
                        p: 3,
                        textAlign: "center",
                        borderRadius: 3,
                        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                        border: "1px solid rgba(0,0,0,0.05)",
                        background:
                          "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                        minHeight: "400px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Box
                        sx={{
                          width: 80,
                          height: 80,
                          borderRadius: "50%",
                          background:
                            "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mb: 1.5,
                          boxShadow: "0 4px 12px rgba(25, 118, 210, 0.2)",
                        }}
                      >
                        <Icon
                          icon="eva:settings-outline"
                          width={40}
                          height={40}
                          color="#1976d2"
                        />
                      </Box>
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 600,
                          color: "text.primary",
                          mb: 1,
                        }}
                      >
                        Select an Operation
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "text.secondary",
                          maxWidth: "300px",
                        }}
                      >
                        Choose a remote operation from the left panel to
                        configure and execute it
                      </Typography>
                    </Card>
                  )}
                </Grid>
              </Grid>
            </Box>
          </TabPanel>
        </Card>
      </TabContext>
      {modalOpen && remoteOperationPerformed && (
        <RemoteOpsStatusModal
          open={modalOpen}
          onClose={handleRemoteOpsStatusModalClose}
          operation={
            remoteOperations.find(
              (operation) => operation.value === remoteOperationPerformed
            ).label
          }
          responseRow={
            operationDetails.response
              ? [
                {
                  id: 1,
                  charge_box_id: operationDetails.chargerId,
                  response: operationDetails.response.response,
                  error: operationDetails.response.errorMessage,
                  details: operationDetails.response.details,
                },
              ]
              : [
                {
                  id: 1,
                  charge_box_id: operationDetails.chargerId,
                  response: "",
                  error: "",
                  details: "",
                },
              ]
          }
        />
      )}
    </>
  );
}
